<template>
    <div class="data-evaluation-page" style="min-width: 1000px;">
        <!-- 企业信息 -->
        <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
                <span>企业信息</span>
            </div>
            <el-table :data="enterpriseInfoData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        {{ scope.row.value }}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 数据资产信息 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据资产信息</span>
            </div>
            <el-table :data="dataAssetInfoData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        {{ scope.row.value }}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 数据详情信息 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据详情</span>
            </div>
            <el-table :data="dataQualityData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        <!-- 如果是合规报告，则显示为链接 -->
                        <div v-if="scope.row.label === '字段信息' || scope.row.label === '抽样数据'" class="file-list">
                            <div v-for="(item, index) in getFileList(scope.row.value)" :key="index" class="file-item">
                                {{ item }}
                                <el-button v-if="isPreviewable(item)" type="text" size="mini" @click="previewFile(item)"
                                    style="margin-left: 8px;">
                                    预览
                                </el-button>
                                <el-button type="text" size="small" @click="downloadFile(item)">
                                    下载
                                </el-button>
                            </div>
                        </div>
                        <!-- 如果是审核意见，则显示为普通文本 -->
                        <div v-else>
                            {{ scope.row.value }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 权重配置 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>权重配置：</span>
                <div style="float: right;">
                    <el-button type="warning" size="small" @click="handleResetWeights">重置权重</el-button>
                    <el-button type="primary" size="small" @click="handleSaveWeights">保存权重</el-button>
                </div>
            </div>

            <!-- 一级指标横向排列 -->
            <div class="level1-flex-container">
                <div v-for="level1 in level1Indicators" :key="level1.id" class="level1-flex-item">
                    <div class="level1-card">
                        <div class="level1-title">
                            <div class="level1-name">{{ level1.description }}</div>
                            <div class="level1-weight-input">
                                <el-input-number v-model="level1.specificGravity" :min="0" :max="100" :step="0.01"
                                    :precision="2" size="mini" :controls="false"
                                    @change="handleLevel1WeightChange(level1)" />
                                <span class="weight-percent">%</span>
                            </div>
                        </div>
                        <div class="level2-container">
                            <div v-for="level2 in getLevel2Indicators(level1.indicatorName)" :key="level2.id"
                                class="level2-item">
                                <div class="level2-name">{{ level2.description }}</div>
                                <div class="level2-weight-input">
                                    <el-input-number v-model="level2.specificGravity" :min="0" :max="100" :step="0.01"
                                        :precision="2" size="mini" :controls="false"
                                        @change="handleLevel2WeightChange(level2, level1)" />
                                    <span class="weight-percent">%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </el-card>
        <!-- 数据总量 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据总量：</span>
            </div>
            <div class="total-elements-config">
                <div class="config-item">
                    <span class="config-label">元素总量：</span>
                    <el-input-number v-model="totalElements" @change="handleTotalElementsChange" :min="0" :step="1"
                        :precision="0" size="small" :controls="false" placeholder="" style="width: 100px;" />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="config-label">记录总量：</span>
                    <el-input-number v-model="totalRecords" @change="handleTotalRecordsChange" :min="0" :step="1"
                        :precision="0" size="small" :controls="false" placeholder="" style="width: 100px;" />
                </div>

            </div>


        </el-card>

        <!-- 数据规范性评分 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据规范性评分：</span>
                <span style="font-size: 20px;">{{ guiFanXingScore.standardizationScore == 0.00 ? '' :
                    Math.floor(parseFloat(guiFanXingScore.standardizationScore) * 100) / 100 }}</span>
                <div style="float: right;">
                    <el-button type="success" size="small">提交评估</el-button>
                    <el-button type="primary" size="small">获取结果</el-button>
                </div>
            </div>

            <el-row :gutter="80">
                <el-col :span="6">
                    <div class="score-input-container">
                        <span class="score-label">值域规范问题数：</span>
                        <el-input-number :controls="false" :min="0" :step="1" :precision="0"
                            @input="calculateDomainStandardScore" v-model="guiFanXingScore.domainProblemCount"
                            type="number" class="score-input" />
                        <span class="score-display">
                            得分：{{ displayScore(guiFanXingScore.domainStandardScore, guiFanXingScore.domainProblemCount,
                                totalElements, false) }}
                        </span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <!-- <div class="score-input-container">
                        <span class="score-label">元数据规范得分：</span>
                        <el-input-number :controls="false" :min="0" :step="1" :precision="0"
                            @input="calculateMetadataStandardScore" v-model="guiFanXingScore.metadataProblemCount"
                            type="number" class="score-input" />
                        <span class="score-display">
                            得分：
                            {{ displayScore(guiFanXingScore.metadataStandardScore,
                                guiFanXingScore.metadataProblemCount,
                                totalElements, false) }}
                        </span>
                    </div> -->
                    <div class="score-input-container">
                        <span class="score-label">元数据规范得分：</span>
                        <el-input-number :controls="false" :min="0" :max="100" :step="1" :precision="0"
                            @input="calculateScore" v-model="guiFanXingScore.metadataStandardScore" type="number"
                            class="score-input" />
                        <span class="score-display">
                            得分：{{ guiFanXingScore.metadataStandardScore || 0 }}
                        </span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="score-input-container">
                        <span class="score-label">格式规范问题数：</span>
                        <el-input-number :controls="false" :min="0" :step="1" :precision="0"
                            @input="calculateFormatStandardScore" v-model="guiFanXingScore.formatProblemCount"
                            type="number" class="score-input" />
                        <span class="score-display">
                            得分：{{ displayScore(guiFanXingScore.formatStandardScore, guiFanXingScore.formatProblemCount,
                                totalElements, false) }}
                        </span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="score-input-container">
                        <span class="score-label">敏感数据问题数：</span>
                        <el-input-number :controls="false" :min="0" :step="1" :precision="0"
                            @input="calculateSensitiveDataScore" v-model="guiFanXingScore.sensitiveProblemCount"
                            type="number" class="score-input" />
                        <span class="score-display">
                            得分：{{ displayScore(guiFanXingScore.sensitiveDataScore,
                                guiFanXingScore.sensitiveProblemCount,
                                totalElements, false) }}
                        </span>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="margin-top: 20px;">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">详情：</span>
                        <el-input type="textarea" v-model="guiFanXingScore.standardizationRemarks"
                            placeholder="请输入内容..." :rows="1" style="flex: 1;" />
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- 数据完整性评分 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据完整性评分：</span>
                <span style="font-size: 20px;">{{ wanZhengXingScore.completenessScore == 0.00 ? '' :
                    Math.floor(parseFloat(wanZhengXingScore.completenessScore) * 100) / 100 }}</span>

                <div style="float: right;">
                    <el-button type="primary" size="small">开始检测</el-button>
                </div>
            </div>

            <el-row :gutter="70">
                <el-col :span="6">
                    <div class="score-input-container">
                        <span class="score-label">元素填充问题数：</span>
                        <el-input-number :controls="false" :min="0" :step="1" :precision="0"
                            @input="calculateElementFillRateScore" v-model="wanZhengXingScore.elementProblemCount"
                            type="number" class="score-input" />
                        <span class="score-display">
                            得分：{{ displayScore(wanZhengXingScore.elementFillRateScore,
                                wanZhengXingScore.elementProblemCount,
                                totalElements, false) }}
                        </span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="score-input-container">
                        <span class="score-label">记录填充问题数：</span>
                        <el-input-number :controls="false" :min="0" :step="1" :precision="0"
                            @input="calculateRecordFillRateScore" v-model="wanZhengXingScore.recordProblemCount"
                            type="number" class="score-input" />
                        <span class="score-display">
                            得分：{{ displayScore(wanZhengXingScore.recordFillRateScore,
                                wanZhengXingScore.recordProblemCount,
                                totalRecords, true) }}
                        </span>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="margin-top: 20px;">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">详情：</span>
                        <el-input v-model="wanZhengXingScore.completenessRemarks" type="textarea" placeholder="请输入内容..."
                            :rows="1" style="flex: 1;" />
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- 数据准确性评分 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据准确性评分：</span>
                <span style="font-size: 20px;">{{ zhunQueXingScore.accuracyScore == 0.00 ? '' :
                    Math.floor(parseFloat(zhunQueXingScore.accuracyScore) * 100) / 100
                    }}</span>
                <div style="float: right;">
                    <el-button type="success" size="small">提交评估</el-button>
                    <el-button type="primary" size="small">获取结果</el-button>
                </div>
            </div>

            <el-row :gutter="70">
                <el-col :span="6">
                    <div class="score-input-container">
                        <span class="score-label">内容准确问题数：</span>
                        <el-input-number :controls="false" :min="0" :step="1" :precision="0"
                            @input="calculateContentAccuracyScore" v-model="zhunQueXingScore.contentProblemCount"
                            type="number" class="score-input" />
                        <span class="score-display">
                            得分：{{ displayScore(zhunQueXingScore.contentAccuracyScore,
                                zhunQueXingScore.contentProblemCount,
                                totalElements, false) }}
                        </span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="score-input-container">
                        <span class="score-label">格式准确问题数：</span>
                        <el-input-number :controls="false" :min="0" :step="1" :precision="0"
                            @input="calculateFormatAccuracyScore" v-model="zhunQueXingScore.formatAccuracyProblemCount"
                            type="number" class="score-input" />
                        <span class="score-display">
                            得分：{{ displayScore(zhunQueXingScore.formatAccuracyScore,
                                zhunQueXingScore.formatAccuracyProblemCount, totalElements, false) }}
                        </span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="score-input-container">
                        <span class="score-label">记录重复问题数：</span>
                        <el-input-number :controls="false" :min="0" :step="1" :precision="0"
                            @input="calculateRepetitionRateScore" v-model="zhunQueXingScore.repetitionProblemCount"
                            type="number" class="score-input" />
                        <span class="score-display">
                            得分：{{ displayScore(zhunQueXingScore.repetitionRateScore,
                                zhunQueXingScore.repetitionProblemCount,
                                totalRecords, true)
                            }}
                        </span>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="margin-top: 20px;">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">详情：</span>
                        <el-input v-model="zhunQueXingScore.accuracyRemarks" type="textarea" placeholder="请输入内容..."
                            :rows="1" style="flex: 1;" />
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- 数据一致性评分 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据一致性评分：</span>
                <span style="font-size: 20px;">{{ yiZhiXingScore.consistencyScore == 0.00 ? '' :
                    Math.floor(parseFloat(yiZhiXingScore.consistencyScore) * 100) / 100
                    }}</span>
                <div style="float: right;">
                    <el-button type="success" size="small">提交评估</el-button>
                    <el-button type="primary" size="small">获取结果</el-button>
                </div>
            </div>

            <el-row :gutter="10">
                <el-col :span="6">
                    <div class="score-input-container">
                        <span class="score-label">相同数据一致性问题数：</span>
                        <el-input-number :controls="false" :min="0" :step="1" :precision="0"
                            @input="calculateSameDataConsistencyScore" v-model="yiZhiXingScore.consistencyProblemCount"
                            type="number" class="score-input" />
                        <span class="score-display">
                            得分：{{ displayScore(yiZhiXingScore.sameDataConsistencyScore,
                                yiZhiXingScore.consistencyProblemCount,
                                totalElements, false)
                            }}
                        </span>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="margin-top: 20px;">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">详情：</span>
                        <el-input v-model="yiZhiXingScore.consistencyRemarks" type="textarea" placeholder="请输入内容..."
                            :rows="1" style="flex: 1;" />
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- 数据时效性评分 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据时效性评分：</span>
                <span style="font-size: 20px;">{{ shiXiaoXingScore.timelinessScore == 0.00 ? '' :
                    Math.floor(parseFloat(shiXiaoXingScore.timelinessScore) * 100) / 100
                    }}</span>
                <div style="float: right;">
                    <el-button type="success" size="small">提交评估</el-button>
                    <el-button type="primary" size="small">获取结果</el-button>
                </div>
            </div>

            <el-row :gutter="30">
                <el-col :span="5" v-if="isRealTime">
                    <div class="score-input-container">
                        <span class="score-label">实时及时性得分：</span>
                        <el-input-number :controls="false" :min="0" :max="100" @input="handleRealtimeTimelinessInput"
                            v-model="shiXiaoXingScore.realtimeTimelinessScore" type="number" class="score-input" />
                    </div>
                </el-col>

                <el-col :span="5" v-else>
                    <div class="score-input-container">
                        <span class="score-label">
                            周期及时性得分：</span>
                        <el-input-number :controls="false" :min="0" :max="100" @input="handlePeriodicTimelinessInput"
                            v-model="shiXiaoXingScore.periodicTimelinessScore" type="number" class="score-input" />
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="margin-top: 20px;">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">详情：</span>
                        <el-input v-model="shiXiaoXingScore.timelinessRemarks" type="textarea" placeholder="请输入内容..."
                            :rows="1" style="flex: 1;" />
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- 数据可访问性评分 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据可访问性评分：</span>
                <span style="font-size: 20px;">{{ keFangWenxingScore.accessibilityScore == 0.00 ? '' :
                    Math.floor(parseFloat(keFangWenxingScore.accessibilityScore) * 100) / 100
                    }}</span>
                <div style="float: right;">
                    <el-button type="success" size="small">提交评估</el-button>
                    <el-button type="primary" size="small">获取结果</el-button>
                </div>
            </div>

            <el-row :gutter="80">
                <el-col :span="5">
                    <div class="score-input-container">
                        <span class="score-label">可访问性得分：</span>
                        <el-input-number :controls="false" :min="0" :max="100" @input="calculateScore"
                            v-model="keFangWenxingScore.dataAccessibilityScore" type="number" class="score-input" />
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="score-input-container">
                        <span class="score-label">可用性得分：</span>
                        <el-input-number :controls="false" :min="0" :max="100" @input="calculateScore"
                            v-model="keFangWenxingScore.dataAvailabilityScore" type="number" class="score-input" />
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="margin-top: 20px;">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">详情：</span>
                        <el-input v-model="keFangWenxingScore.accessibilityRemarks" type="textarea"
                            placeholder="请输入内容..." :rows="1" style="flex: 1;" />
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- 最终得分 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>最终得分</span>
            </div>

            <el-row :gutter="30">
                <el-col :span="5">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">数据质量评估得分：</span>
                        <span style="font-size: 23px; font-weight: bold; margin-top: -7px; color: rgb(88, 156, 253);">{{
                            parseFloat(dataQualityScore).toFixed(2) }}</span>
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- 问题详情 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>问题详情</span>
                <div style="float: right;">
                    <el-button type="primary" size="small" @click="addProblemRow">添加问题</el-button>
                </div>
            </div>

            <el-table :data="qualityProblems" style="width: 100%" border>
                <el-table-column prop="type" label="问题类型" min-width="15" align="center">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.type" placeholder="请选择问题类型" size="small" style="width: 100%;">
                            <el-option v-for="option in getAvailableProblemTypes(scope.$index)" :key="option.value"
                                :label="option.label" :value="option.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>

                <el-table-column prop="fieldName" label="字段名称" min-width="20" align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.fieldName" placeholder="请输入字段名称" size="small"></el-input>
                    </template>
                </el-table-column>

                <el-table-column prop="number" label="问题条数" width="150" align="center">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.number" :min="0" :step="1" :precision="0" size="small"
                            style="width: 100%;" :controls="false"></el-input-number>
                    </template>
                </el-table-column>

                <el-table-column prop="errorExample" label="错误数据样例" align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.errorExample" type="textarea" :rows="1" placeholder="请输入错误数据样例"
                            size="small"></el-input>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="80" fixed="right" align="center">
                    <template slot-scope="scope">
                        <el-button type="danger" icon="el-icon-delete" size="mini" circle
                            @click="removeProblemRow(scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div v-if="qualityProblems.length === 0" style="text-align: center; padding: 20px; color: #909399;">
                暂无问题记录，点击"添加问题"按钮开始添加
            </div>
        </el-card>




        <!-- 数据来源 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据来源</span>
            </div>

            <el-row :gutter="10">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">详细来源：</span>
                        <el-input v-model="sourceDetail" type="textarea" placeholder="请输入内容..." :rows="2"
                            style="flex: 1;" />
                    </div>
                </el-col>
            </el-row>
        </el-card>


        <!-- 数据用途 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据用途</span>
            </div>

            <el-row :gutter="10">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">用途：</span>
                        <el-input v-model="purpose" type="textarea" placeholder="用于..." :rows="2" style="flex: 1;" />
                    </div>
                </el-col>
            </el-row>
        </el-card>


        <!-- 工作执行记录 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>工作执行记录</span>
            </div>

            <el-row :gutter="10">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">记录：</span>
                        <el-input v-model="workExecution" type="textarea" placeholder="请输入内容..." :rows="3"
                            style="flex: 1;" />
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- 问题总结 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>问题总结</span>
            </div>

            <el-row :gutter="10">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">存在问题：</span>
                        <el-input v-model="existingIssues" type="textarea" placeholder="请输入内容..." :rows="3"
                            style="flex: 1;" />
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- AI问题总结 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;" v-if="AIExistingIssues">
            <div slot="header" class="clearfix">
                <span>AI问题总结</span>
            </div>

            <el-row :gutter="10">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">存在问题：</span>
                        <el-input v-model="AIExistingIssues" type="textarea" placeholder="请输入内容..." :rows="3"
                            style="flex: 1;" />
                    </div>
                </el-col>
            </el-row>
        </el-card>


        <!-- 综合评价 -->
        <!-- <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>评价</span>
            </div>

            <el-row :gutter="10">
                <el-col :span="24">
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 8px;">综合评价:</span>
                        <el-input v-model="evaluation" type="textarea" placeholder="请输入内容..." :rows="1"
                            style="flex: 1;" />

                    </div>
                </el-col>
            </el-row>
        </el-card> -->

        <!-- 数据质量评价报告 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据质量评价报告</span>
            </div>
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="compact-panel">



                        <div class="compact-section">
                            <!--
                            <el-button class="compact-btn" type="primary"
                                :disabled="isGeneratingAI || isAIReportGenerated" :loading="isGeneratingAI"
                                @click="click1(false, 1)">
                                {{ isAIReportGenerated ? '已生成' : (isGeneratingAI ? '生成中...' : 'AI生成问题总结') }}
                            </el-button>
                            
                            -->
                            <el-button class="compact-btn" type="primary" @click="click1(useAI, 2)"
                                style="margin-left: 12px;">
                                智能生成质量评价报告
                            </el-button>
                        </div>


                        <div class="compact-section" v-if="AIExistingIssues">
                            <div class="compact-row">
                                <span class="compact-label">是否使用AI问题总结：</span>
                                <el-radio-group v-model="useAI" class="compact-radio">
                                    <el-radio :label="true" border size="mini">是</el-radio>
                                    <el-radio :label="false" border size="mini">否</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                        <!-- 文件展示区域 -->
                        <div v-if="sysReportName" class="compact-section">
                            <div class="file-row">
                                <span class="file-name">{{ sysReportName }}</span>
                                <div class="file-buttons">
                                    <el-button v-if="isPreviewable(sysReportName)" type="text" size="mini"
                                        @click="previewFile(sysReportName)" class="file-btn preview">
                                        预览
                                    </el-button>
                                    <el-button type="text" size="mini" @click="downloadFile(sysReportName)"
                                        class="file-btn download">
                                        下载
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <!-- 上传区域 -->
                    <el-upload ref="upload" drag action='#' :auto-upload="false" :limit="10"
                        :on-change="handleReportFileChange" :on-remove="handleReportFileRemove" :file-list="reportFile"
                        :multiple="true">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">点击或拖拽文件到此处<br>
                            <span style="color: gray; font-size: 10px;">
                                支持 word 格式 文件大小不得超过{{ fileSizeLimit }}M</span>
                        </div>
                    </el-upload>
                </el-col>
            </el-row>
        </el-card>

        <!-- 底部操作按钮 -->
        <div style="margin-top: 30px;  display: flex; justify-content: space-evenly;">
            <el-button type="warning" size="medium" @click="close('/DataQualityManager')" style="width: 120px;">
                关闭
            </el-button>
            <el-button type="primary" size="medium" @click="save" style="width: 120px;">
                保存
            </el-button>
            <el-button type="danger" size="medium" @click="handleReject" style="width:120px;">
                驳回
            </el-button>
            <el-button type="success" size="medium" :disabled="isSubmitDisabled" @click="handlePass"
                style="width: 120px;">
                通过
            </el-button>
        </div>

        <!-- 文件预览组件 -->
        <file-preview ref="filePreview" download-base-url="/web/dataQuality/download" />
    </div>
</template>
<script>
import FilePreview from '@/components/FilePreview.vue';

export default {
    name: 'DataQualityEvaluation',
    components: {
        FilePreview
    },
    data() {
        return {
            userInfo: '',
            companyUserID: '',
            registrationId: '',
            reportFile: [],  // 报告文件
            fileSizeLimit: 100, // 文件大小限制单位MB
            enterpriseInfoData: [],
            dataAssetInfoData: [],
            dataQualityData: [],
            isRealTime: false,
            sysReportName: '',
            totalElements: 0, // 元素总数
            totalRecords: 0, // 记录总数
            sourceDetail: '', // 数据源详情
            purpose: '',  // 数据目的
            workExecution: '',  // 工作执行记录

            originalWeightConfig: [], // 保存原始权重配置用于重置

            qualityProblems: [], // 质量问题列表

            weightConfig: [], // 原始权重配置数据
            level1Indicators: [], // 一级指标评分配置
            level2Indicators: [], // 二级指标
            guiFanXingScore: {       // 规范性
                standardizationScore: '',  // 规范性得分
                domainStandardScore: '',    //值域规范得分
                domainProblemCount: 0,     //值域规范问题数
                metadataStandardScore: '',  //元数据规范得分
                metadataProblemCount: 0,   //元数据规范问题数
                formatStandardScore: '',   //格式规范得分
                formatProblemCount: 0,     //格式规范问题数
                sensitiveDataScore: '',    //敏感数据脱敏得分
                sensitiveProblemCount: 0,  //敏感数据问题数
                standardizationRemarks: ''    //规范性备注信息
            },
            wanZhengXingScore: {       // 完整性
                completenessScore: '',       //完整性评分
                elementFillRateScore: '',   //元素填充率得分
                elementProblemCount: 0,     //元素填充率问题数
                recordFillRateScore: '',   // 记录填充率得分
                recordProblemCount: 0,      //记录填充率问题数
                completenessRemarks: ''       //完整性备注信息
            },
            zhunQueXingScore: {       //准确性
                accuracyScore: '',      //准确性评分
                contentAccuracyScore: '',  //内容准确率得分
                contentProblemCount: 0,   //内容准确率问题数
                formatAccuracyScore: '',   //格式准确率得分
                formatAccuracyProblemCount: 0, //格式准确率问题数
                repetitionRateScore: '',  //记录重复率得分
                repetitionProblemCount: 0, //记录重复率问题数
                accuracyRemarks: ''          //准确性备注信息
            },
            yiZhiXingScore: {       //一致性
                consistencyScore: '',      //一致性评分
                sameDataConsistencyScore: '',   //相同数据一致性得分
                consistencyProblemCount: 0,    //相同数据一致性问题数
                consistencyRemarks: ''          //一致性备注信息     
            },
            shiXiaoXingScore: {       //时效性
                timelinessScore: '',             //时效性评分
                realtimeTimelinessScore: '',     //实时及时性得分
                periodicTimelinessScore: '',    //周期及时性得分
                timelinessRemarks: ''              //时效性备注信息
            },
            keFangWenxingScore: {  // 可访问性
                accessibilityScore: '',         //可访问性评分
                dataAccessibilityScore: '',     //数据可访问性得分
                dataAvailabilityScore: '',      // 数据可用性得分
                accessibilityRemarks: ''         //可访问性备注信息
            },
            dataQualityScore: 0.00,  // 数据质量总分
            existingIssues: '',            //存在问题描述
            evaluation: '',               //综合评价
            AIExistingIssues: '',            //AI存在问题描述
            thisDataAssetAllInfo: '',
            thisCompanyAllInfo: '',
            useAI: true, // 默认使用AI问题总结
            isGeneratingAI: false, // AI报告生成中状态
            isGeneratingReport: false, // 质量报告生成中状态
            isAIReportGenerated: false, // AI报告是否已生成

            calculateTimer: null, // 防抖定时器
        }
    },
    created() {
        // 从路由中获取传递的参数
        this.registrationId = this.$route.query.registrationId || '';
        this.userInfo = JSON.parse(window.localStorage.getItem('user'));

        if (this.registrationId) {
            this.initializeApplication();
        }
    },
    methods: {
        initializeApplication() {
            // 获取数据详情数据
            this.getRequest(`/web/dataQualityDetail/query?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data && resp.data.object) {
                        // console.log(resp.data.object);
                        let dataQualityInfoData = resp.data.object;
                        // 初始化问题详述数据
                        if (dataQualityInfoData.qualityProblemList && Array.isArray(dataQualityInfoData.qualityProblemList)) {
                            this.qualityProblems = dataQualityInfoData.qualityProblemList.map(problem => ({
                                type: problem.type || '',
                                fieldName: problem.fieldName || '',
                                number: problem.number || 0,
                                errorExample: problem.errorExample || ''
                            }));
                        } else {
                            this.qualityProblems = [];
                        }
                        this.sourceDetail = dataQualityInfoData.source;
                        // 初始化问题详述数据
                        if (dataQualityInfoData.qualityProblemList && Array.isArray(dataQualityInfoData.qualityProblemList)) {
                            this.qualityProblems = dataQualityInfoData.qualityProblemList.map(problem => ({
                                type: problem.type || '',
                                fieldName: problem.fieldName || '',
                                number: problem.number || 0,
                                errorExample: problem.errorExample || ''
                            }));
                        } else {
                            this.qualityProblems = [];
                        }
                        this.workExecution = dataQualityInfoData.workExecution;
                        this.totalElements = dataQualityInfoData.elementsNum; // 元素总数
                        this.totalRecords = dataQualityInfoData.linesNum; // 记录总数

                        // 数据质量信息
                        this.dataQualityData = [
                            { label: '字段信息', value: dataQualityInfoData.dataFieldFile },
                            { label: '抽样数据', value: dataQualityInfoData.dataDetailedFile },
                            { label: '冷数据处理方式', value: dataQualityInfoData.oldDataHandle }
                        ];
                        // 初始化评分数据 - 直接从 dataQualityInfoData 对象中获取
                        // 规范性评分
                        this.guiFanXingScore = {
                            standardizationScore: dataQualityInfoData.standardizationScore ?? '',
                            domainStandardScore: dataQualityInfoData.domainStandardScore ?? '',
                            domainProblemCount: dataQualityInfoData.domainStandardNum,
                            metadataStandardScore: dataQualityInfoData.metadataStandardScore ?? '',
                            metadataProblemCount: dataQualityInfoData.metadataStandardNum ?? '',
                            formatStandardScore: dataQualityInfoData.formatStandardScore ?? '',
                            formatProblemCount: dataQualityInfoData.formatStandardNum ?? '',
                            sensitiveDataScore: dataQualityInfoData.sensitiveDataScore ?? '',
                            sensitiveProblemCount: dataQualityInfoData.sensitiveDataNum ?? '',
                            standardizationRemarks: dataQualityInfoData.standardizationRemarks || ''
                        };

                        // 完整性评分
                        this.wanZhengXingScore = {
                            completenessScore: dataQualityInfoData.completenessScore ?? '',
                            elementFillRateScore: dataQualityInfoData.elementFillRateScore ?? '',
                            elementProblemCount: dataQualityInfoData.elementFillRateNum ?? '',
                            recordFillRateScore: dataQualityInfoData.recordFillRateScore ?? '',
                            recordProblemCount: dataQualityInfoData.recordFillRateNum ?? '',
                            completenessRemarks: dataQualityInfoData.completenessRemarks || ''
                        };

                        // 准确性评分
                        this.zhunQueXingScore = {
                            accuracyScore: dataQualityInfoData.accuracyScore ?? '',
                            contentAccuracyScore: dataQualityInfoData.contentAccuracyScore ?? '',
                            contentProblemCount: dataQualityInfoData.contentAccuracyNum ?? '',
                            formatAccuracyScore: dataQualityInfoData.formatAccuracyScore ?? '',
                            formatAccuracyProblemCount: dataQualityInfoData.formatAccuracyNum ?? '',
                            repetitionRateScore: dataQualityInfoData.repetitionRateScore ?? '',
                            repetitionProblemCount: dataQualityInfoData.repetitionRateNum ?? '',
                            accuracyRemarks: dataQualityInfoData.accuracyRemarks || ''
                        };

                        // 一致性评分
                        this.yiZhiXingScore = {
                            consistencyScore: dataQualityInfoData.consistencyScore ?? '',
                            sameDataConsistencyScore: dataQualityInfoData.sameDataConsistencyScore ?? '',
                            consistencyProblemCount: dataQualityInfoData.sameDataConsistencyNum ?? '',
                            consistencyRemarks: dataQualityInfoData.consistencyRemarks || ''
                        };

                        // 时效性评分
                        this.shiXiaoXingScore = {
                            timelinessScore: dataQualityInfoData.timelinessScore ?? '',
                            realtimeTimelinessScore: dataQualityInfoData.realtimeTimelinessScore ?? '',
                            periodicTimelinessScore: dataQualityInfoData.periodicTimelinessScore ?? '',
                            timelinessRemarks: dataQualityInfoData.timelinessRemarks || ''
                        };

                        // 可访问性评分
                        this.keFangWenxingScore = {
                            accessibilityScore: dataQualityInfoData.accessibilityScore ?? '',
                            dataAccessibilityScore: dataQualityInfoData.dataAccessibilityScore ?? '',
                            dataAvailabilityScore: dataQualityInfoData.dataAvailabilityScore ?? '',
                            accessibilityRemarks: dataQualityInfoData.accessibilityRemarks || ''
                        };

                        // 总分和其他信息
                        this.dataQualityScore = dataQualityInfoData.dataQualityScore ?? 0.00;
                        this.existingIssues = dataQualityInfoData.existingIssues || '';
                        this.evaluation = dataQualityInfoData.evaluation || '';

                        // 根据得分反向计算问题数
                        this.calculateProblemCountsFromScores();
                    }


                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
            // 获取企业信息
            this.getRequest(`/web/companyInfo/queryByRegistrationId?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data) {
                        this.thisCompanyAllInfo = resp.data
                        this.enterpriseInfoData = [
                            { label: '企业名称', value: resp.data.companyName },
                            { label: '统一社会信用代码', value: resp.data.socialCreditCode },
                            { label: '经营范围', value: resp.data.businessNature },
                            { label: '联系人姓名', value: resp.data.contactsName },
                            { label: '联系电话', value: resp.data.contactsPhone }
                        ];

                        this.companyUserID = resp.data.userId


                    }
                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
            // 查询数据资产信息
            this.getRequest(`/web/dataAssets/queryForReview?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data) {
                        this.thisDataAssetAllInfo = resp.data

                        // 判断是否为实时更新
                        this.isRealTime = resp.data.updateCycle === '实时';

                        // 数据资产信息
                        this.dataAssetInfoData = [
                            { label: '数据资产名称', value: resp.data.assetName },
                            { label: '数据来源', value: resp.data.dataSource },
                            { label: '所属行业', value: resp.data.industry },
                            { label: '更新周期', value: resp.data.updateCycle },
                            { label: '数据覆盖地域', value: resp.data.region },
                            { label: '应用场景描述', value: resp.data.scenario },
                            { label: '数据资产简介', value: resp.data.description }
                        ];

                        if (this.purpose === '') {
                            this.purpose = resp.data.scenario;
                            console.log(111);
                        }

                    }
                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
            // 获取权重配置
            this.getRequest('/web/dataQuality/queryQualityWeight')
                .then(resp => {
                    // console.log(resp);
                    if (resp.data && resp.data.object) {
                        this.weightConfig = resp.data.object;
                        this.processWeightConfig();
                    }
                })
                .catch(error => {
                    console.error('获取权重配置失败:', error);
                });



        },

        // 处理元素总量变化
        handleTotalElementsChange() {
            // 重新计算所有基于元素总量的得分
            this.calculateDomainStandardScore();
            this.calculateMetadataStandardScore();
            this.calculateFormatStandardScore();
            this.calculateSensitiveDataScore();
            this.calculateElementFillRateScore();
            this.calculateContentAccuracyScore();
            this.calculateFormatAccuracyScore();
            this.calculateSameDataConsistencyScore();

            // 重新计算总分
            this.calculateScore();
        },

        // 处理记录总量变化
        handleTotalRecordsChange() {
            // 重新计算所有基于记录总量的得分
            this.calculateRecordFillRateScore();
            this.calculateRepetitionRateScore();

            // 重新计算总分
            this.calculateScore();
        },

        // 获取可用的选项类型（排除已被其他行选择的类型）
        getAvailableProblemTypes(currentIndex) {
            const allTypes = [
                // { label: '规范性问题', value: '规范性问题' },
                // { label: '完整性问题', value: '完整性问题' },
                // { label: '准确性问题', value: '准确性问题' },
                // { label: '一致性问题', value: '一致性问题' }

                { label: '值域规范问题', value: '值域规范问题' },
                { label: '元数据规范问题', value: '元数据规范问题' },
                { label: '格式规范问题', value: '格式规范问题' },
                { label: '敏感数据规范问题', value: '敏感数据规范问题' },

                { label: '元素填充问题', value: '元素填充问题' },
                { label: '记录填充问题', value: '记录填充问题' },

                { label: '内容准确问题', value: '内容准确问题' },
                { label: '格式准确问题', value: '格式准确问题' },
                { label: '记录重复问题', value: '记录重复问题' },

                { label: '相同数据一致性问题', value: '相同数据一致性问题' },




            ];

            // 获取其他行已选择的类型
            // const selectedTypes = this.qualityProblems
            //     .filter((_, index) => index !== currentIndex) // 排除当前行
            //     .map(item => item.type)
            //     .filter(type => type && type.trim() !== ''); // 过滤空值

            // 返回所有类型，但会在选项中标记禁用状态
            return allTypes;
        },

        // 检查某个选项是否应该被禁用
        // isTypeOptionDisabled(typeValue, currentIndex) {
        //     // 如果当前行已经选择了这个类型，不应该禁用
        //     if (this.qualityProblems[currentIndex]?.type === typeValue) {
        //         return false;
        //     }

        //     // 检查其他行是否已经选择了这个类型
        //     const isSelectedByOthers = this.qualityProblems.some((item, index) => {
        //         return index !== currentIndex && item.type === typeValue;
        //     });

        //     return isSelectedByOthers;
        // },

        // 检查整个选择框是否应该被禁用
        // isTypeDisabled(currentType, currentIndex) {
        //     // 如果当前行已经有类型，允许编辑
        //     if (currentType && currentType.trim() !== '') {
        //         return false;
        //     }

        //     // 获取所有可用的类型
        //     const availableTypes = this.getAvailableProblemTypes(currentIndex);

        //     // 检查是否还有可用的类型
        //     const hasAvailableOptions = availableTypes.some(option =>
        //         !this.isTypeOptionDisabled(option.value, currentIndex)
        //     );

        //     // 如果没有可用的选项，禁用整个选择框
        //     return !hasAvailableOptions;
        // },

        // 添加问题行（修改后的方法）
        addProblemRow() {
            // 检查是否还有可用的类型
            // const allTypes = ['规范性问题', '完整性问题', '准确性问题', '一致性问题'];
            // const usedTypes = this.qualityProblems.map(item => item.type).filter(type => type);
            // const availableTypes = allTypes.filter(type => !usedTypes.includes(type));

            // if (availableTypes.length === 0) {
            //     this.$message.warning('所有问题类型都已使用，无法添加新问题');
            //     return;
            // }

            this.qualityProblems.push({
                id: Date.now(),
                type: '',
                fieldName: '',
                number: 0,
                errorExample: ''
            });
        },

        // 删除问题行（修改后的方法）
        removeProblemRow(index) {
            this.qualityProblems.splice(index, 1);
        },

        // 处理权重配置数据
        processWeightConfig() {
            // 分离一级和二级指标
            this.level1Indicators = this.weightConfig.filter(item => item.level === '1');
            this.level2Indicators = this.weightConfig.filter(item => item.level === '2');

            // 将小数权重转换为百分比（乘以100）
            this.level1Indicators.forEach(item => {
                if (item.specificGravity !== undefined && item.specificGravity !== null) {
                    item.specificGravity = Math.round(item.specificGravity * 100);
                }
            });

            this.level2Indicators.forEach(item => {
                if (item.specificGravity !== undefined && item.specificGravity !== null) {
                    item.specificGravity = Math.round(item.specificGravity * 100);
                }
            });

            // 保存原始权重配置用于重置（转换为百分比格式）
            this.originalWeightConfig = JSON.parse(JSON.stringify(this.weightConfig));
            this.originalWeightConfig.forEach(item => {
                if (item.specificGravity !== undefined && item.specificGravity !== null) {
                    item.specificGravity = Math.round(item.specificGravity * 100);
                }
            });

            // 保存原始权重配置用于重置
            this.originalWeightConfig = JSON.parse(JSON.stringify(this.weightConfig));
            // 指标名称映射
            const LEVEL1_NAME_MAP = {
                'standard': '数据规范性',
                'completeness': '数据完整性',
                'accuracy': '数据准确性',
                'consistency': '数据一致性',
                'timeliness': '数据时效性',
                'accessibility': '数据可访问性'
            };

            const LEVEL2_NAME_MAP = {
                'domain_standard': '值域规范',
                'metadata_standard': '元数据规范',
                'format_standard': '格式规范',
                'sensitive_data': '敏感数据脱敏',
                'element_fill_rate': '元素填充率',
                'record_fill_rate': '记录填充率',
                'content_accuracy': '内容准确率',
                'format_accuracy': '格式准确率',
                'repetition_rate': '记录重复率',
                'same_data_consistency': '相同数据一致性',
                'realtime_timeliness': '实时及时性',
                'periodic_timeliness': '周期及时性',
                'data_accessibility': '数据可访问性',
                'data_availability': '数据可用性'
            };

            // 更新指标描述
            this.level1Indicators.forEach(item => {
                if (LEVEL1_NAME_MAP[item.indicatorName]) {
                    item.description = LEVEL1_NAME_MAP[item.indicatorName];
                }
            });

            this.level2Indicators.forEach(item => {
                if (LEVEL2_NAME_MAP[item.indicatorName]) {
                    item.description = LEVEL2_NAME_MAP[item.indicatorName];
                }
            });
        },

        // 重置权重
        handleResetWeights() {
            this.$confirm('确定要重置所有权重为0吗？', '重置权重', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 重置一级指标权重为0%
                this.level1Indicators.forEach(item => {
                    item.specificGravity = 0;
                });

                // 重置二级指标权重为0%
                this.level2Indicators.forEach(item => {
                    item.specificGravity = 0;
                });

                this.$message.success('权重已重置为0%');
                // 重新计算所有得分
                this.calculateAllScoresFrontend();
            }).catch(() => {
                // 用户取消重置
            });
        },

        // 保存权重
        async handleSaveWeights() {
            // 验证一级指标权重总和是否为1
            const level1Total = this.level1Indicators.reduce((sum, item) => {
                return sum + (parseFloat(item.specificGravity) || 0);
            }, 0);

            if (Math.abs(level1Total - 100) > 0.1) {  // 允许1%的误差
                await this.showValidationError(
                    `一级指标权重总和应为100%，当前为: ${level1Total.toFixed(2)}%`,
                    '一级指标权重总和错误'
                );
                return;
            }

            // 验证每个一级指标下的二级指标权重总和是否为100%
            let isValid = true;
            let errorMessages = [];

            this.level1Indicators.forEach(level1 => {
                const level2Items = this.getLevel2Indicators(level1.indicatorName);
                const level2Total = level2Items.reduce((sum, item) => {
                    return sum + (parseFloat(item.specificGravity) || 0);
                }, 0);

                // 检查二级指标总和是否等于100%
                if (Math.abs(level2Total - 100) > 0.1) { // 允许1%的误差
                    isValid = false;
                    errorMessages.push(`${level1.description}: 二级指标权重总和应为100%，当前为: ${level2Total.toFixed(0)}%`);
                }
            });

            if (!isValid) {
                await this.showValidationError(
                    '权重配置不合法：\n' + errorMessages.join('\n'),
                    '二级指标权重总和错误'
                );
                return;
            }

            // 构建保存数据（将百分比转换回小数）
            const saveData = {
                weightConfig: [...this.level1Indicators, ...this.level2Indicators].map(item => ({
                    id: item.id,
                    indicatorName: item.indicatorName,
                    specificGravity: (parseFloat(item.specificGravity) || 0) / 100, // 转换为小数
                    level: item.level
                }))
            };
            // 更新原始权重配置
            this.originalWeightConfig = JSON.parse(JSON.stringify(this.weightConfig));
            this.originalWeightConfig.forEach(item => {
                if (item.specificGravity !== undefined && item.specificGravity !== null) {
                    item.specificGravity = Math.round(item.specificGravity);
                }
            });

            // 重新计算所有得分
            this.calculateAllScoresFrontend();


        },
        // 显示验证错误并提供撤销选项
        showValidationError(message, title) {
            return new Promise((resolve) => {
                this.$confirm(message, title, {
                    confirmButtonText: '撤销修改',
                    cancelButtonText: '继续编辑',
                    type: 'error',
                    showClose: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    distinguishCancelAndClose: true
                }).then(() => {
                    // 用户点击"撤销修改"
                    this.undoWeightChanges();
                    this.$message.info('已撤销本次修改');
                    resolve(false);
                }).catch(action => {
                    // 用户点击"继续编辑"
                    if (action === 'cancel') {
                        this.$message.info('请继续编辑权重配置');
                    }
                    resolve(false);
                });
            });
        },

        // 撤销权重修改
        undoWeightChanges() {
            // 恢复一级指标权重（百分比格式）
            this.level1Indicators.forEach(currentLevel1 => {
                const originalLevel1 = this.originalWeightConfig.find(
                    item => item.id === currentLevel1.id && item.level === '1'
                );
                if (originalLevel1) {
                    currentLevel1.specificGravity = originalLevel1.specificGravity;
                }
            });

            // 恢复二级指标权重（百分比格式）
            this.level2Indicators.forEach(currentLevel2 => {
                const originalLevel2 = this.originalWeightConfig.find(
                    item => item.id === currentLevel2.id && item.level === '2'
                );
                if (originalLevel2) {
                    currentLevel2.specificGravity = originalLevel2.specificGravity;
                }
            });

            // 重新计算所有得分
            this.calculateScore();
        },



        getLevel2Indicators(level1Name) {
            // 一级指标和二级指标的映射关系
            const LEVEL1_TO_LEVEL2_MAP = {
                'standard': ['domain_standard', 'metadata_standard', 'format_standard', 'sensitive_data'],
                'completeness': ['element_fill_rate', 'record_fill_rate'],
                'accuracy': ['content_accuracy', 'format_accuracy', 'repetition_rate'],
                'consistency': ['same_data_consistency'],
                'accessibility': ['data_accessibility', 'data_availability']
            };

            // 数据时效性：根据isRealTime决定显示哪个二级指标
            let level2Names = [];
            if (level1Name === 'timeliness') {
                level2Names = this.isRealTime ? ['realtime_timeliness'] : ['periodic_timeliness'];
            } else {
                level2Names = LEVEL1_TO_LEVEL2_MAP[level1Name] || [];
            }

            return this.level2Indicators.filter(item => level2Names.includes(item.indicatorName));
        },
        // 处理一级指标权重变化
        handleLevel1WeightChange(level1) {
            // 这里可以添加权重验证逻辑，比如确保所有一级指标权重之和为1
            this.validateWeights();
        },

        // 处理二级指标权重变化
        handleLevel2WeightChange(level2, parentLevel1) {
            // 这里可以添加权重验证逻辑，比如确保每个一级指标下的二级指标权重之和等于该一级指标的权重
            this.validateLevel2Weights(parentLevel1);
        },

        // 验证权重总和
        validateWeights() {
            const totalWeight = this.level1Indicators.reduce((sum, item) => {
                return sum + (parseFloat(item.specificGravity) || 0);
            }, 0);

            // 如果总权重不等于1，可以给出提示
            if (Math.abs(totalWeight - 1) > 0.01) {
                // 这里可以添加用户提示
                // this.$message.warning(`一级指标权重总和应为1，当前为: ${totalWeight.toFixed(2)}`);
            }
        },


        // 验证二级指标权重
        validateLevel2Weights(parentLevel1) {
            const level2Items = this.getLevel2Indicators(parentLevel1.indicatorName);
            const totalWeight = level2Items.reduce((sum, item) => {
                return sum + (parseFloat(item.specificGravity) || 0);
            }, 0);

            // 如果二级指标总权重不等于1，可以给出提示
            if (Math.abs(totalWeight - 1) > 0.01) {
                // 这里可以添加用户提示
                // this.$message.warning(`二级指标权重总和应为1，当前为: ${totalWeight.toFixed(2)}`);
            }
        },

        // 文件下载
        async downloadFile(filename) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/dataQuality/download?registrationId=' + this.registrationId + '&fileName=' + filename,
                    responseType: 'blob'
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },

        // 预览文件
        async previewFile(fileName) {
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) {
                this.$message.warning('文件名不能为空');
                return;
            }

            this.isPreviewLoading = true;
            try {
                await this.$refs.filePreview.openPreview(
                    { fileName: fileNameStr },
                    this.registrationId
                );
            } catch (error) {
                console.error('预览失败:', error);
                this.$message.error('文件预览失败: ' + (error.message || ''));
            } finally {
                this.isPreviewLoading = false;
            }
        },

        handleReportFileRemove(file, fileList) {
            this.reportFile = fileList;
        },
        // 提交报告
        handleReportFileChange(file, fileList) {
            // 校验文件类型
            const isWord = file.name.endsWith('.doc') || file.name.endsWith('.docx');
            if (!isWord) {
                this.$message.error('仅支持 word 文件格式！');
                // 从fileList中移除不符合条件的文件
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return;
            }

            // 校验文件大小
            const isLtLimit = file.size / 1024 / 1024 < this.fileSizeLimit;
            if (!isLtLimit) {
                this.$message.error(`上传文件大小不能超过 ${this.fileSizeLimit}MB！`);
                // 从fileList中移除不符合条件的文件
                const index = fileList.indexOf(file);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return;
            }
            this.reportFile = fileList;
        },

        // 处理实时及时性得分输入
        handleRealtimeTimelinessInput(value) {
            // 当输入实时及时性得分时，清空周期及时性得分
            if (value && value !== '') {
                this.shiXiaoXingScore.periodicTimelinessScore = '';
            }
            // 调用通用计算方法
            this.calculateScore();
        },

        // 处理周期及时性得分输入
        handlePeriodicTimelinessInput(value) {
            // 当输入周期及时性得分时，清空实时及时性得分
            if (value && value !== '') {
                this.shiXiaoXingScore.realtimeTimelinessScore = '';
            }
            // 调用通用计算方法
            this.calculateScore();
        },

        // 根据问题数计算得分
        calculateScoreFromProblems(problemCount, total) {
            if (!total || total === 0 || problemCount === undefined || problemCount === null) {
                return 0;
            }

            // 确保问题数不为负数
            const validProblemCount = Math.max(0, problemCount);
            if (validProblemCount === 0) {
                // 问题数为0时，也得有上限，比如99.99
                return 100;
            }


            // 确保问题数不超过总数
            const adjustedProblemCount = Math.min(validProblemCount, total);

            const score = (1 - adjustedProblemCount / total) * 100;

            // 设置得分上限为99.99，下限为0
            const finalScore = Math.max(0, Math.min(99.99, score));

            return parseFloat(finalScore.toFixed(2));
        },
        // 各个指标的计算方法
        calculateDomainStandardScore() {
            if (this.totalElements > 0) {
                this.guiFanXingScore.domainStandardScore = this.calculateScoreFromProblems(
                    this.guiFanXingScore.domainProblemCount,
                    this.totalElements
                );
            } else {
                this.guiFanXingScore.domainStandardScore = 0;
            }
            this.calculateScore();
        },

        calculateMetadataStandardScore() {
            if (this.totalElements > 0) {
                this.guiFanXingScore.metadataStandardScore = this.calculateScoreFromProblems(
                    this.guiFanXingScore.metadataProblemCount,
                    this.totalElements
                );
            } else {
                this.guiFanXingScore.metadataStandardScore = 0;
            }
            this.calculateScore();
        },

        calculateFormatStandardScore() {
            if (this.totalElements > 0) {
                this.guiFanXingScore.formatStandardScore = this.calculateScoreFromProblems(
                    this.guiFanXingScore.formatProblemCount,
                    this.totalElements
                );
            } else {
                this.guiFanXingScore.formatStandardScore = 0;
            }
            this.calculateScore();
        },

        calculateSensitiveDataScore() {
            if (this.totalElements > 0) {
                this.guiFanXingScore.sensitiveDataScore = this.calculateScoreFromProblems(
                    this.guiFanXingScore.sensitiveProblemCount,
                    this.totalElements
                );
            } else {
                this.guiFanXingScore.sensitiveDataScore = 0;
            }
            this.calculateScore();
        },

        calculateElementFillRateScore() {
            if (this.totalElements > 0) {
                this.wanZhengXingScore.elementFillRateScore = this.calculateScoreFromProblems(
                    this.wanZhengXingScore.elementProblemCount,
                    this.totalElements
                );
            } else {
                this.wanZhengXingScore.elementFillRateScore = 0;
            }
            this.calculateScore();
        },

        calculateRecordFillRateScore() {
            if (this.totalRecords > 0) {
                this.wanZhengXingScore.recordFillRateScore = this.calculateScoreFromProblems(
                    this.wanZhengXingScore.recordProblemCount,
                    this.totalRecords
                );
            } else {
                this.wanZhengXingScore.recordFillRateScore = 0;
            }
            this.calculateScore();
        },

        calculateContentAccuracyScore() {
            if (this.totalElements > 0) {
                this.zhunQueXingScore.contentAccuracyScore = this.calculateScoreFromProblems(
                    this.zhunQueXingScore.contentProblemCount,
                    this.totalElements
                );
            } else {
                this.zhunQueXingScore.contentAccuracyScore = 0;
            }
            this.calculateScore();
        },

        calculateFormatAccuracyScore() {
            if (this.totalElements > 0) {
                this.zhunQueXingScore.formatAccuracyScore = this.calculateScoreFromProblems(
                    this.zhunQueXingScore.formatAccuracyProblemCount,
                    this.totalElements
                );
            } else {
                this.zhunQueXingScore.formatAccuracyScore = 0;
            }
            this.calculateScore();
        },

        calculateRepetitionRateScore() {
            if (this.totalRecords > 0) {
                this.zhunQueXingScore.repetitionRateScore = this.calculateScoreFromProblems(
                    this.zhunQueXingScore.repetitionProblemCount,
                    this.totalRecords
                );
            } else {
                this.zhunQueXingScore.repetitionRateScore = 0;
            }
            this.calculateScore();
        },

        calculateSameDataConsistencyScore() {
            if (this.totalElements > 0) {
                this.yiZhiXingScore.sameDataConsistencyScore = this.calculateScoreFromProblems(
                    this.yiZhiXingScore.consistencyProblemCount,
                    this.totalElements
                );
            } else {
                this.yiZhiXingScore.sameDataConsistencyScore = 0;
            }
            this.calculateScore();
        },


        // 根据得分反向计算问题数
        calculateProblemCountsFromScores() {
            const elements = this.totalElements;
            const records = this.totalRecords;

            // 如果元素总数或记录总数为0，无法计算问题数
            if (!elements || elements === 0 || !records || records === 0) {
                return;
            }

            // 规范性评分问题数计算
            const standardScores = [
                { score: this.guiFanXingScore.domainStandardScore, key: 'domainProblemCount', total: elements },
                { score: this.guiFanXingScore.metadataStandardScore, key: 'metadataProblemCount', total: elements },
                { score: this.guiFanXingScore.formatStandardScore, key: 'formatProblemCount', total: elements },
                { score: this.guiFanXingScore.sensitiveDataScore, key: 'sensitiveProblemCount', total: elements }
            ];

            standardScores.forEach(item => {
                if (item.score !== undefined && item.score !== null && item.score !== '') {
                    this.guiFanXingScore[item.key] = this.calculateProblemCountFromScore(item.score, item.total);
                }
            });

            // 完整性评分问题数计算
            if (this.wanZhengXingScore.elementFillRateScore !== undefined && this.wanZhengXingScore.elementFillRateScore !== null && this.wanZhengXingScore.elementFillRateScore !== '') {
                this.wanZhengXingScore.elementProblemCount = this.calculateProblemCountFromScore(this.wanZhengXingScore.elementFillRateScore, elements);
            }
            if (this.wanZhengXingScore.recordFillRateScore !== undefined && this.wanZhengXingScore.recordFillRateScore !== null && this.wanZhengXingScore.recordFillRateScore !== '') {
                this.wanZhengXingScore.recordProblemCount = this.calculateProblemCountFromScore(this.wanZhengXingScore.recordFillRateScore, records);
            }

            // 准确性评分问题数计算
            if (this.zhunQueXingScore.contentAccuracyScore !== undefined && this.zhunQueXingScore.contentAccuracyScore !== null && this.zhunQueXingScore.contentAccuracyScore !== '') {
                this.zhunQueXingScore.contentProblemCount = this.calculateProblemCountFromScore(this.zhunQueXingScore.contentAccuracyScore, elements);
            }
            if (this.zhunQueXingScore.formatAccuracyScore !== undefined && this.zhunQueXingScore.formatAccuracyScore !== null && this.zhunQueXingScore.formatAccuracyScore !== '') {
                this.zhunQueXingScore.formatAccuracyProblemCount = this.calculateProblemCountFromScore(this.zhunQueXingScore.formatAccuracyScore, elements);
            }
            if (this.zhunQueXingScore.repetitionRateScore !== undefined && this.zhunQueXingScore.repetitionRateScore !== null && this.zhunQueXingScore.repetitionRateScore !== '') {
                this.zhunQueXingScore.repetitionProblemCount = this.calculateProblemCountFromScore(this.zhunQueXingScore.repetitionRateScore, records);
            }

            // 一致性评分问题数计算
            if (this.yiZhiXingScore.sameDataConsistencyScore !== undefined && this.yiZhiXingScore.sameDataConsistencyScore !== null && this.yiZhiXingScore.sameDataConsistencyScore !== '') {
                this.yiZhiXingScore.consistencyProblemCount = this.calculateProblemCountFromScore(this.yiZhiXingScore.sameDataConsistencyScore, elements);
            }
        },

        // 根据得分计算问题数
        calculateProblemCountFromScore(score, total) {
            if (score === undefined || score === null || score === '' || !total || total === 0) {
                return 0;
            }
            const numericScore = parseFloat(score);
            if (isNaN(numericScore) || numericScore >= 100) {
                return 0;
            }
            const problemCount = total * (1 - numericScore / 100);
            return Math.round(problemCount);
        },



        // 显示得分的方法
        displayScore(existingScore, problemCount, total, isRecord = false) {
            // 如果已有得分（从后端获取），直接显示（但限制上限）
            if (existingScore !== undefined && existingScore !== null && existingScore !== '') {
                const numericScore = parseFloat(existingScore);
                if (!isNaN(numericScore)) {
                    // 限制显示得分上限为99.99
                    const displayScore = Math.min(100, numericScore);
                    return displayScore.toFixed(2);
                }
                return existingScore;
            }

            // 计算并显示得分
            const actualTotal = isRecord ? this.totalRecords : this.totalElements;
            const score = this.calculateScoreFromProblems(problemCount, actualTotal);
            return score.toFixed(2);
        },

        // 前端计算所有得分

        calculateAllScoresFrontend() {

            // 获取规范性相关的二级指标权重
            const standardLevel2Indicators = this.getLevel2Indicators('standard');

            // 计算规范性得分（使用配置的权重）
            let standardizationScore = 0;
            let standardTotalWeight = 0;

            // 值域规范得分
            const domainStandardItem = standardLevel2Indicators.find(item => item.indicatorName === 'domain_standard');
            if (domainStandardItem) {
                const weight = (parseFloat(domainStandardItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.guiFanXingScore.domainStandardScore) || 0;
                // 应用得分上限
                const cappedScore = Math.min(100, score);
                standardizationScore += cappedScore * weight;
                standardTotalWeight += weight;
            }

            // 元数据规范得分
            const metadataStandardItem = standardLevel2Indicators.find(item => item.indicatorName === 'metadata_standard');
            if (metadataStandardItem) {
                const weight = (parseFloat(metadataStandardItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.guiFanXingScore.metadataStandardScore) || 0;
                const cappedScore = Math.min(100, score);
                standardizationScore += cappedScore * weight;
                standardTotalWeight += weight;
            }

            // 格式规范得分
            const formatStandardItem = standardLevel2Indicators.find(item => item.indicatorName === 'format_standard');
            if (formatStandardItem) {
                const weight = (parseFloat(formatStandardItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.guiFanXingScore.formatStandardScore) || 0;
                const cappedScore = Math.min(100, score);
                standardizationScore += cappedScore * weight;
                standardTotalWeight += weight;
            }

            // 敏感数据脱敏得分
            const sensitiveDataItem = standardLevel2Indicators.find(item => item.indicatorName === 'sensitive_data');
            if (sensitiveDataItem) {
                const weight = (parseFloat(sensitiveDataItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.guiFanXingScore.sensitiveDataScore) || 0;
                const cappedScore = Math.min(100, score);
                standardizationScore += cappedScore * weight;
                standardTotalWeight += weight;
            }

            // 计算加权平均，并应用上限
            if (standardTotalWeight > 0) {
                // const rawScore = standardizationScore / standardTotalWeight;
                // console.log("rawScore" ,rawScore);
                // // 应用得分上限
                // const finalScore = Math.min(100, parseFloat(rawScore));
                // console.log("finalScore" ,finalScore);

                // this.guiFanXingScore.standardizationScore = finalScore;
                this.guiFanXingScore.standardizationScore = standardizationScore / standardTotalWeight;
            } else {
                this.guiFanXingScore.standardizationScore = 0;
            }


            // 完整性得分
            const completenessLevel2Indicators = this.getLevel2Indicators('completeness');
            let completenessScore = 0;
            let completenessTotalWeight = 0;

            // 元素填充率得分
            const elementFillRateItem = completenessLevel2Indicators.find(item => item.indicatorName === 'element_fill_rate');
            if (elementFillRateItem) {
                const weight = (parseFloat(elementFillRateItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.wanZhengXingScore.elementFillRateScore) || 0;
                const cappedScore = Math.min(100, score);
                completenessScore += cappedScore * weight;
                completenessTotalWeight += weight;
            }

            // 记录填充率得分
            const recordFillRateItem = completenessLevel2Indicators.find(item => item.indicatorName === 'record_fill_rate');
            if (recordFillRateItem) {
                const weight = (parseFloat(recordFillRateItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.wanZhengXingScore.recordFillRateScore) || 0;
                const cappedScore = Math.min(100, score);
                completenessScore += cappedScore * weight;
                completenessTotalWeight += weight;
            }

            if (completenessTotalWeight > 0) {
                // const rawScore = completenessScore / completenessTotalWeight;
                // const finalScore = Math.min(100, parseFloat(rawScore.toFixed(2)));
                // this.wanZhengXingScore.completenessScore = finalScore;
                this.wanZhengXingScore.completenessScore = completenessScore / completenessTotalWeight;

            } else {
                this.wanZhengXingScore.completenessScore = 0;
            }

            // 准确性得分
            const accuracyLevel2Indicators = this.getLevel2Indicators('accuracy');
            let accuracyScore = 0;
            let accuracyTotalWeight = 0;

            // 内容准确率得分
            const contentAccuracyItem = accuracyLevel2Indicators.find(item => item.indicatorName === 'content_accuracy');
            if (contentAccuracyItem) {
                const weight = (parseFloat(contentAccuracyItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.zhunQueXingScore.contentAccuracyScore) || 0;
                const cappedScore = Math.min(100, score);
                accuracyScore += cappedScore * weight;
                accuracyTotalWeight += weight;
            }

            // 格式准确率得分
            const formatAccuracyItem = accuracyLevel2Indicators.find(item => item.indicatorName === 'format_accuracy');
            if (formatAccuracyItem) {
                const weight = (parseFloat(formatAccuracyItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.zhunQueXingScore.formatAccuracyScore) || 0;
                const cappedScore = Math.min(100, score);
                accuracyScore += cappedScore * weight;
                accuracyTotalWeight += weight;
            }

            // 记录重复率得分
            const repetitionRateItem = accuracyLevel2Indicators.find(item => item.indicatorName === 'repetition_rate');
            if (repetitionRateItem) {
                const weight = (parseFloat(repetitionRateItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.zhunQueXingScore.repetitionRateScore) || 0;
                const cappedScore = Math.min(100, score);
                accuracyScore += cappedScore * weight;
                accuracyTotalWeight += weight;
            }

            if (accuracyTotalWeight > 0) {
                // const rawScore = accuracyScore / accuracyTotalWeight;
                // const finalScore = Math.min(100, parseFloat(rawScore.toFixed(2)));
                // this.zhunQueXingScore.accuracyScore = finalScore;
                this.zhunQueXingScore.accuracyScore = accuracyScore / accuracyTotalWeight;

            } else {
                this.zhunQueXingScore.accuracyScore = 0;
            }

            // 一致性得分
            const consistencyLevel2Indicators = this.getLevel2Indicators('consistency');
            let consistencyScore = 0;
            let consistencyTotalWeight = 0;

            const sameDataConsistencyItem = consistencyLevel2Indicators.find(item => item.indicatorName === 'same_data_consistency');
            if (sameDataConsistencyItem) {
                const weight = (parseFloat(sameDataConsistencyItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.yiZhiXingScore.sameDataConsistencyScore) || 0;
                const cappedScore = Math.min(100, score);
                consistencyScore += cappedScore * weight;
                consistencyTotalWeight += weight;
            }

            if (consistencyTotalWeight > 0) {
                // const rawScore = consistencyScore / consistencyTotalWeight;
                // const finalScore = Math.min(100, parseFloat(rawScore.toFixed(2)));
                // this.yiZhiXingScore.consistencyScore = finalScore;
                this.yiZhiXingScore.consistencyScore = consistencyScore / consistencyTotalWeight;

            } else {
                this.yiZhiXingScore.consistencyScore = 0;
            }

            // 时效性得分
            const timelinessLevel2Indicators = this.getLevel2Indicators('timeliness');
            let timelinessScore = 0;
            let timelinessTotalWeight = 0;

            if (this.isRealTime) {
                const realtimeTimelinessItem = timelinessLevel2Indicators.find(item => item.indicatorName === 'realtime_timeliness');
                if (realtimeTimelinessItem) {
                    const weight = (parseFloat(realtimeTimelinessItem.specificGravity) || 0) / 100;
                    const score = parseFloat(this.shiXiaoXingScore.realtimeTimelinessScore) || 0;
                    const cappedScore = Math.min(100, score);
                    timelinessScore += cappedScore * weight;
                    timelinessTotalWeight += weight;
                }
            } else {
                const periodicTimelinessItem = timelinessLevel2Indicators.find(item => item.indicatorName === 'periodic_timeliness');
                if (periodicTimelinessItem) {
                    const weight = (parseFloat(periodicTimelinessItem.specificGravity) || 0) / 100;
                    const score = parseFloat(this.shiXiaoXingScore.periodicTimelinessScore) || 0;
                    const cappedScore = Math.min(100, score);
                    timelinessScore += cappedScore * weight;
                    timelinessTotalWeight += weight;
                }
            }

            if (timelinessTotalWeight > 0) {
                // const rawScore = timelinessScore / timelinessTotalWeight;
                // const finalScore = Math.min(100, parseFloat(rawScore.toFixed(2)));
                // this.shiXiaoXingScore.timelinessScore = finalScore;

                this.shiXiaoXingScore.timelinessScore = timelinessScore / timelinessTotalWeight;

            } else {
                this.shiXiaoXingScore.timelinessScore = 0;
            }

            // 可访问性得分
            const accessibilityLevel2Indicators = this.getLevel2Indicators('accessibility');
            let accessibilityScore = 0;
            let accessibilityTotalWeight = 0;

            // 数据可访问性得分
            const dataAccessibilityItem = accessibilityLevel2Indicators.find(item => item.indicatorName === 'data_accessibility');
            if (dataAccessibilityItem) {
                const weight = (parseFloat(dataAccessibilityItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.keFangWenxingScore.dataAccessibilityScore) || 0;
                const cappedScore = Math.min(100, score);
                accessibilityScore += cappedScore * weight;
                accessibilityTotalWeight += weight;
            }

            // 数据可用性得分
            const dataAvailabilityItem = accessibilityLevel2Indicators.find(item => item.indicatorName === 'data_availability');
            if (dataAvailabilityItem) {
                const weight = (parseFloat(dataAvailabilityItem.specificGravity) || 0) / 100;
                const score = parseFloat(this.keFangWenxingScore.dataAvailabilityScore) || 0;
                const cappedScore = Math.min(100, score);
                accessibilityScore += cappedScore * weight;
                accessibilityTotalWeight += weight;
            }

            if (accessibilityTotalWeight > 0) {
                // const rawScore = accessibilityScore / accessibilityTotalWeight;
                // const finalScore = Math.min(100, parseFloat(rawScore.toFixed(2)));
                // this.keFangWenxingScore.accessibilityScore = finalScore;
                this.keFangWenxingScore.accessibilityScore = accessibilityScore / accessibilityTotalWeight;

            } else {
                this.keFangWenxingScore.accessibilityScore = 0;
            }

            // 计算最终数据质量得分（使用权重配置）
            let totalScore = 0;
            let totalWeight = 0;

            // 规范性权重
            const standardizationWeightItem = this.level1Indicators.find(item => item.indicatorName === 'standard');
            const standardizationWeight = standardizationWeightItem ? (parseFloat(standardizationWeightItem.specificGravity) || 0) / 100 : 0.1667;
            const standardizationScoreValue = parseFloat(this.guiFanXingScore.standardizationScore) || 0;
            const cappedStandardizationScore = Math.min(100, standardizationScoreValue);
            totalScore += cappedStandardizationScore * standardizationWeight;
            totalWeight += standardizationWeight;

            // 完整性权重
            const completenessWeightItem = this.level1Indicators.find(item => item.indicatorName === 'completeness');
            const completenessWeight = completenessWeightItem ? (parseFloat(completenessWeightItem.specificGravity) || 0) / 100 : 0.1667;
            const completenessScoreValue = parseFloat(this.wanZhengXingScore.completenessScore) || 0;
            const cappedCompletenessScore = Math.min(100, completenessScoreValue);
            totalScore += cappedCompletenessScore * completenessWeight;
            totalWeight += completenessWeight;

            // 准确性权重
            const accuracyWeightItem = this.level1Indicators.find(item => item.indicatorName === 'accuracy');
            const accuracyWeight = accuracyWeightItem ? (parseFloat(accuracyWeightItem.specificGravity) || 0) / 100 : 0.1667;
            const accuracyScoreValue = parseFloat(this.zhunQueXingScore.accuracyScore) || 0;
            const cappedAccuracyScore = Math.min(100, accuracyScoreValue);
            totalScore += cappedAccuracyScore * accuracyWeight;
            totalWeight += accuracyWeight;

            // 一致性权重
            const consistencyWeightItem = this.level1Indicators.find(item => item.indicatorName === 'consistency');
            const consistencyWeight = consistencyWeightItem ? (parseFloat(consistencyWeightItem.specificGravity) || 0) / 100 : 0.1667;
            const consistencyScoreValue = parseFloat(this.yiZhiXingScore.consistencyScore) || 0;
            const cappedConsistencyScore = Math.min(100, consistencyScoreValue);
            totalScore += cappedConsistencyScore * consistencyWeight;
            totalWeight += consistencyWeight;

            // 时效性权重
            const timelinessWeightItem = this.level1Indicators.find(item => item.indicatorName === 'timeliness');
            const timelinessWeight = timelinessWeightItem ? (parseFloat(timelinessWeightItem.specificGravity) || 0) / 100 : 0.1667;
            const timelinessScoreValue = parseFloat(this.shiXiaoXingScore.timelinessScore) || 0;
            const cappedTimelinessScore = Math.min(100, timelinessScoreValue);
            totalScore += cappedTimelinessScore * timelinessWeight;
            totalWeight += timelinessWeight;

            // 可访问性权重
            const accessibilityWeightItem = this.level1Indicators.find(item => item.indicatorName === 'accessibility');
            const accessibilityWeight = accessibilityWeightItem ? (parseFloat(accessibilityWeightItem.specificGravity) || 0) / 100 : 0.1667;
            const accessibilityScoreValue = parseFloat(this.keFangWenxingScore.accessibilityScore) || 0;
            const cappedAccessibilityScore = Math.min(100, accessibilityScoreValue);
            totalScore += cappedAccessibilityScore * accessibilityWeight;
            totalWeight += accessibilityWeight;

            // 计算加权平均，并应用上限
            if (totalWeight > 0) {
                const rawTotalScore = totalScore / totalWeight;
                const finalTotalScore = Math.min(100, parseFloat(rawTotalScore.toFixed(2)));
                this.dataQualityScore = finalTotalScore;
            } else {
                this.dataQualityScore = 0.00;
            }
        },


        // 计算规范性得分
        calculateScore() {
            // 使用防抖机制，避免频繁调用接口
            clearTimeout(this.calculateTimer);
            this.calculateTimer = setTimeout(() => {
                // 实现互斥逻辑：当输入实时及时性得分时，清空周期及时性得分，反之亦然
                if (this.shiXiaoXingScore.realtimeTimelinessScore && this.shiXiaoXingScore.realtimeTimelinessScore !== '') {
                    this.shiXiaoXingScore.periodicTimelinessScore = '';
                } else if (this.shiXiaoXingScore.periodicTimelinessScore && this.shiXiaoXingScore.periodicTimelinessScore !== '') {
                    this.shiXiaoXingScore.realtimeTimelinessScore = '';
                }

                // 收集所有评分数据
                const allScores = {
                    // 规范性评分
                    domainStandardScore: this.guiFanXingScore.domainStandardScore ? parseFloat(this.guiFanXingScore.domainStandardScore) : null,
                    metadataStandardScore: this.guiFanXingScore.metadataStandardScore ? parseFloat(this.guiFanXingScore.metadataStandardScore) : null,
                    formatStandardScore: this.guiFanXingScore.formatStandardScore ? parseFloat(this.guiFanXingScore.formatStandardScore) : null,
                    sensitiveDataScore: this.guiFanXingScore.sensitiveDataScore ? parseFloat(this.guiFanXingScore.sensitiveDataScore) : null,

                    // 完整性评分
                    elementFillRateScore: this.wanZhengXingScore.elementFillRateScore ? parseFloat(this.wanZhengXingScore.elementFillRateScore) : null,
                    recordFillRateScore: this.wanZhengXingScore.recordFillRateScore ? parseFloat(this.wanZhengXingScore.recordFillRateScore) : null,

                    // 准确性评分
                    contentAccuracyScore: this.zhunQueXingScore.contentAccuracyScore ? parseFloat(this.zhunQueXingScore.contentAccuracyScore) : null,
                    formatAccuracyScore: this.zhunQueXingScore.formatAccuracyScore ? parseFloat(this.zhunQueXingScore.formatAccuracyScore) : null,
                    repetitionRateScore: this.zhunQueXingScore.repetitionRateScore ? parseFloat(this.zhunQueXingScore.repetitionRateScore) : null,

                    // 一致性评分
                    sameDataConsistencyScore: this.yiZhiXingScore.sameDataConsistencyScore ? parseFloat(this.yiZhiXingScore.sameDataConsistencyScore) : null,

                    // 时效性评分（互斥处理）
                    realtimeTimelinessScore: this.shiXiaoXingScore.realtimeTimelinessScore ? parseFloat(this.shiXiaoXingScore.realtimeTimelinessScore) : null,
                    periodicTimelinessScore: this.shiXiaoXingScore.periodicTimelinessScore ? parseFloat(this.shiXiaoXingScore.periodicTimelinessScore) : null,

                    // 可访问性评分
                    dataAccessibilityScore: this.keFangWenxingScore.dataAccessibilityScore ? parseFloat(this.keFangWenxingScore.dataAccessibilityScore) : null,
                    dataAvailabilityScore: this.keFangWenxingScore.dataAvailabilityScore ? parseFloat(this.keFangWenxingScore.dataAvailabilityScore) : null,
                };

                // 前端计算所有得分
                this.calculateAllScoresFrontend();
            }, 500); // 500ms 防抖延迟
        },

        getFileList(fileValue) {
            if (!fileValue) return [];

            if (Array.isArray(fileValue)) {
                return fileValue;
            }

            if (typeof fileValue === 'string') {
                // 如果是逗号分隔的文件名，分割成数组
                return fileValue.split(',').map(item => item.trim()).filter(item => item);
            }

            return [fileValue];
        },

        // 获取文件扩展名
        getFileExtension(filename) {
            if (!filename) return '';
            const parts = String(filename).split('.');
            return parts.length > 1 ? parts.pop().toLowerCase() : '';
        },


        // 判断文件是否可预览
        isPreviewable(fileName) {
            if (!fileName) return false;

            // 确保fileName是字符串
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) return false;

            const ext = this.getFileExtension(fileNameStr);
            const previewableTypes = [
                'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', // 图片
                'pdf', // PDF
                'xls', 'xlsx', 'csv', // Excel文件
                'doc', 'docx', // Word文档
                'txt', 'json', 'xml', 'csv', 'log', 'js', 'css', 'html', 'md' // 文本文件
            ];
            return previewableTypes.includes(ext);
        },


        // 驳回
        async handleReject() {
            if (this.existingIssues === "") {
                this.$message.error("请输入存在的问题!");
                return;
            }

            try {
                const submitData = {
                    registrationId: this.registrationId,
                    companyName: this.enterpriseInfoData.find(item => item.label === '企业名称')?.value,
                    assetName: this.dataAssetInfoData.find(item => item.label === '数据资产名称')?.value,
                    industry: this.dataAssetInfoData.find(item => item.label === '所属行业')?.value,
                    dataDetailedFile: this.getFileNames('抽样数据'),
                    dataFieldFile: this.getFileNames('字段信息'),
                    oldDataHandle: this.dataQualityData.find(item => item.label === '冷数据处理方式')?.value,
                    existingIssues: this.existingIssues,
                    evaluation: this.evaluation,
                    result: "reject",
                    operator: this.userInfo.id
                };

                const response = await this.$axios.post('/web/dataQualityDetail/review', submitData, {
                    headers: { 'X-User-Id': this.userInfo.id }
                });

                if (response.data?.status === 200) {
                    this.$confirm('驳回成功！', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        showCancelButton: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.close('/DataQualityManager');
                    });
                } else {
                    this.$message.error('提交失败: ' + (response.data.msg || '未知错误'));
                }
            } catch (error) {
                console.error('提交失败:', error);
                this.$message.error('提交失败: ' + error.message);
            }
        },

        // 获取文件名数组
        getFileNames(label) {
            const fileValue = this.dataQualityData.find(item => item.label === label)?.value;
            if (Array.isArray(fileValue)) {
                return fileValue.map(file => typeof file === 'string' ? file.split('/').pop() : file.name || file);
            }
            return [fileValue].map(file => typeof file === 'string' ? file.split('/').pop() : file.name || file);
        },

        // 通过
        async handlePass() {
            try {
                // 上传所有报告文件
                let platformQualityReportUrl = '';

                // 只上传第一个报告文件
                if (this.reportFile.length > 0) {
                    const file = this.reportFile[0];
                    const response = await this.uploadSingleFile(file, 'evaluationReport');
                    if (response.data && response.data.status === 200 && response.data.object) {
                        platformQualityReportUrl = response.data.object;
                    } else {
                        throw new Error(`文件 ${file.name} 上传失败: ${response.data.msg || '未知错误'}`);
                    }
                }
                const submitData = {
                    registrationId: this.registrationId,           // 数据资产id
                    companyName: this.enterpriseInfoData.find(item => item.label === '企业名称')?.value,   // 企业名称
                    assetName: this.dataAssetInfoData.find(item => item.label === '数据资产名称')?.value,  // 数据资产名称
                    industry: this.dataAssetInfoData.find(item => item.label === '所属行业')?.value,   // 所属行业
                    dataDetailedFile: Array.isArray(this.dataQualityData.find(item => item.label === '抽样数据')?.value)
                        ? this.dataQualityData.find(item => item.label === '抽样数据')?.value.map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file)
                        : [this.dataQualityData.find(item => item.label === '抽样数据')?.value].map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file),   // 数据文件(仅文件名)
                    dataFieldFile: Array.isArray(this.dataQualityData.find(item => item.label === '字段信息')?.value)
                        ? this.dataQualityData.find(item => item.label === '字段信息')?.value.map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file)
                        : [this.dataQualityData.find(item => item.label === '字段信息')?.value].map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file),      // 字段文件(仅文件名)
                    oldDataHandle: this.dataQualityData.find(item => item.label === '冷数据处理方式')?.value,      // 冷数据处理方式
                    dataQualityScore: this.dataQualityScore, // 数据质量总评分


                    source: this.sourceDetail,  // 数据来源
                    purpose: this.purpose,  // 数据用途
                    workExecution: this.workExecution,  // 工作执行

                    // 元素总数和记录总数
                    elementsNum: this.totalElements,
                    linesNum: this.totalRecords,

                    qualityProblemList: this.qualityProblems,  // 问题列表
                    // 规范性评分相关
                    standardizationScore: this.guiFanXingScore.standardizationScore,   // 规范性评分
                    domainStandardScore: this.guiFanXingScore.domainStandardScore,    // 值域规范得分
                    domainStandardNum: this.guiFanXingScore.domainProblemCount,     // 值域规范问题数
                    metadataStandardScore: this.guiFanXingScore.metadataStandardScore,  // 元数据规范得分
                    metadataStandardNum: this.guiFanXingScore.metadataProblemCount,   // 元数据规范问题数
                    formatStandardScore: this.guiFanXingScore.formatStandardScore,    // 格式规范得分
                    formatStandardNum: this.guiFanXingScore.formatProblemCount,     // 格式规范问题数
                    sensitiveDataScore: this.guiFanXingScore.sensitiveDataScore,     // 敏感数据脱敏得分
                    sensitiveDataNum: this.guiFanXingScore.sensitiveProblemCount,  // 敏感数据问题数
                    standardizationRemarks: this.guiFanXingScore.standardizationRemarks,     // 规范性备注信息

                    // 完整性评分相关
                    completenessScore: this.wanZhengXingScore.completenessScore,       // 完整性评分
                    elementFillRateScore: this.wanZhengXingScore.elementFillRateScore,    // 元素填充率得分
                    elementFillRateNum: this.wanZhengXingScore.elementProblemCount,     // 元素填充率问题数
                    recordFillRateScore: this.wanZhengXingScore.recordFillRateScore,     // 记录填充率得分
                    recordFillRateNum: this.wanZhengXingScore.recordProblemCount,      // 记录填充率问题数
                    completenessRemarks: this.wanZhengXingScore.completenessRemarks,         // 完整性备注信息

                    // 准确性评分相关
                    accuracyScore: this.zhunQueXingScore.accuracyScore,         // 准确性评分
                    contentAccuracyScore: this.zhunQueXingScore.contentAccuracyScore,  // 内容准确率得分
                    contentAccuracyNum: this.zhunQueXingScore.contentProblemCount,   // 内容准确率问题数
                    formatAccuracyScore: this.zhunQueXingScore.formatAccuracyScore,   // 格式准确率得分
                    formatAccuracyNum: this.zhunQueXingScore.formatAccuracyProblemCount, // 格式准确率问题数
                    repetitionRateScore: this.zhunQueXingScore.repetitionRateScore,   // 记录重复率得分
                    repetitionRateNum: this.zhunQueXingScore.repetitionProblemCount, // 记录重复率问题数
                    accuracyRemarks: this.zhunQueXingScore.accuracyRemarks,           // 准确性备注信息

                    // 一致性评分相关
                    consistencyScore: this.yiZhiXingScore.consistencyScore,            // 一致性评分
                    sameDataConsistencyScore: this.yiZhiXingScore.sameDataConsistencyScore,    // 相同数据一致性得分
                    sameDataConsistencyNum: this.yiZhiXingScore.consistencyProblemCount,    // 相同数据一致性问题数
                    consistencyRemarks: this.yiZhiXingScore.consistencyRemarks,              // 一致性备注信息

                    // 时效性评分相关
                    timelinessScore: this.shiXiaoXingScore.timelinessScore,             // 时效性评分
                    realtimeTimelinessScore: this.shiXiaoXingScore.realtimeTimelinessScore,     // 实时及时性得分
                    periodicTimelinessScore: this.shiXiaoXingScore.periodicTimelinessScore,     // 周期及时性得分
                    timelinessRemarks: this.shiXiaoXingScore.timelinessRemarks,               // 时效性备注信息

                    // 可访问性评分相关
                    accessibilityScore: this.keFangWenxingScore.accessibilityScore,          // 可访问性评分
                    dataAccessibilityScore: this.keFangWenxingScore.dataAccessibilityScore,      // 数据可访问性得分
                    dataAvailabilityScore: this.keFangWenxingScore.dataAvailabilityScore,       // 数据可用性得分
                    accessibilityRemarks: this.keFangWenxingScore.accessibilityRemarks,            // 可访问性备注信息

                    existingIssues: this.existingIssues,            // 存在问题描述
                    evaluation: this.evaluation,                // 综合评价
                    evaluationReport: platformQualityReportUrl,                // 评估报告
                    result: "approve",  // 审核结果   approve  通过,  reject  驳回
                    operator: this.userInfo.id,           // 操作人
                };


                // 调用表单提交接口
                const response = await this.$axios.post('/web/dataQualityDetail/review', submitData, {
                    headers: {
                        'X-User-Id': this.userInfo.id
                    }
                });


                if (response.data && response.data.status === 200) {
                    // 提交成功后显示确认弹窗
                    this.$confirm('审核成功！', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        showCancelButton: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.close('/DataQualityManager');
                    });
                } else {
                    this.$message.error('提交失败: ' + (response.data.msg || '未知错误'));
                }
            } catch (error) {
                console.error('提交失败:', error);
                this.$message.error('提交失败: ' + error.message);
            }


        },

        // 单个文件上传方法
        uploadSingleFile(file, fileType) {
            const formData = new FormData();
            formData.append('file', file.raw || file);
            formData.append('registrationId', this.registrationId);
            formData.append('type', fileType);

            return this.$axios.post('/web/dataQuality/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                // 在响应中添加文件类型信息
                if (response.data && response.data.status === 200 && response.data.object) {
                    response.data.fileType = fileType; // 添加文件类型标识
                }
                return response;
            });
        },
        async click1(useAI, buttonIndex) {
            try {

                if (buttonIndex === 1) {
                    // AI生成问题总结按钮
                    this.isGeneratingAI = true;
                } else if (buttonIndex === 2) {
                    // 生成质量评价报告按钮
                    this.isGeneratingReport = true;
                }


                // 构建 DataQualityAssessment 对象
                const dataQualityAssessment = {
                    registrationId: this.registrationId,           // 数据资产id
                    companyName: this.enterpriseInfoData.find(item => item.label === '企业名称')?.value,   // 企业名称
                    assetName: this.dataAssetInfoData.find(item => item.label === '数据资产名称')?.value,  // 数据资产名称
                    industry: this.dataAssetInfoData.find(item => item.label === '所属行业')?.value,   // 所属行业
                    dataDetailedFile: Array.isArray(this.dataQualityData.find(item => item.label === '抽样数据')?.value)
                        ? this.dataQualityData.find(item => item.label === '抽样数据')?.value.map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file)
                        : [this.dataQualityData.find(item => item.label === '抽样数据')?.value].map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file),   // 数据文件(仅文件名)
                    dataFieldFile: Array.isArray(this.dataQualityData.find(item => item.label === '字段信息')?.value)
                        ? this.dataQualityData.find(item => item.label === '字段信息')?.value.map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file)
                        : [this.dataQualityData.find(item => item.label === '字段信息')?.value].map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file),      // 字段文件(仅文件名)
                    oldDataHandle: this.dataQualityData.find(item => item.label === '冷数据处理方式')?.value,      // 冷数据处理方式
                    dataQualityScore: this.dataQualityScore, // 数据质量总评分


                    source: this.sourceDetail,  // 数据来源
                    purpose: this.purpose,  // 数据用途
                    workExecution: this.workExecution,  // 工作执行

                    // 元素总数和记录总数
                    elementsNum: this.totalElements,
                    linesNum: this.totalRecords,

                    qualityProblemList: this.qualityProblems,  // 问题列表
                    // 规范性评分相关
                    standardizationScore: this.guiFanXingScore.standardizationScore,   // 规范性评分
                    domainStandardScore: this.guiFanXingScore.domainStandardScore,    // 值域规范得分
                    domainStandardNum: this.guiFanXingScore.domainProblemCount,     // 值域规范问题数
                    metadataStandardScore: this.guiFanXingScore.metadataStandardScore,  // 元数据规范得分
                    metadataStandardNum: this.guiFanXingScore.metadataProblemCount,   // 元数据规范问题数
                    formatStandardScore: this.guiFanXingScore.formatStandardScore,    // 格式规范得分
                    formatStandardNum: this.guiFanXingScore.formatProblemCount,     // 格式规范问题数
                    sensitiveDataScore: this.guiFanXingScore.sensitiveDataScore,     // 敏感数据脱敏得分
                    sensitiveDataNum: this.guiFanXingScore.sensitiveProblemCount,  // 敏感数据问题数
                    standardizationRemarks: this.guiFanXingScore.standardizationRemarks,     // 规范性备注信息

                    // 完整性评分相关
                    completenessScore: this.wanZhengXingScore.completenessScore,       // 完整性评分
                    elementFillRateScore: this.wanZhengXingScore.elementFillRateScore,    // 元素填充率得分
                    elementFillRateNum: this.wanZhengXingScore.elementProblemCount,     // 元素填充率问题数
                    recordFillRateScore: this.wanZhengXingScore.recordFillRateScore,     // 记录填充率得分
                    recordFillRateNum: this.wanZhengXingScore.recordProblemCount,      // 记录填充率问题数
                    completenessRemarks: this.wanZhengXingScore.completenessRemarks,         // 完整性备注信息

                    // 准确性评分相关
                    accuracyScore: this.zhunQueXingScore.accuracyScore,         // 准确性评分
                    contentAccuracyScore: this.zhunQueXingScore.contentAccuracyScore,  // 内容准确率得分
                    contentAccuracyNum: this.zhunQueXingScore.contentProblemCount,   // 内容准确率问题数
                    formatAccuracyScore: this.zhunQueXingScore.formatAccuracyScore,   // 格式准确率得分
                    formatAccuracyNum: this.zhunQueXingScore.formatAccuracyProblemCount, // 格式准确率问题数
                    repetitionRateScore: this.zhunQueXingScore.repetitionRateScore,   // 记录重复率得分
                    repetitionRateNum: this.zhunQueXingScore.repetitionProblemCount, // 记录重复率问题数
                    accuracyRemarks: this.zhunQueXingScore.accuracyRemarks,           // 准确性备注信息

                    // 一致性评分相关
                    consistencyScore: this.yiZhiXingScore.consistencyScore,            // 一致性评分
                    sameDataConsistencyScore: this.yiZhiXingScore.sameDataConsistencyScore,    // 相同数据一致性得分
                    sameDataConsistencyNum: this.yiZhiXingScore.consistencyProblemCount,    // 相同数据一致性问题数
                    consistencyRemarks: this.yiZhiXingScore.consistencyRemarks,              // 一致性备注信息

                    // 时效性评分相关
                    timelinessScore: this.shiXiaoXingScore.timelinessScore,             // 时效性评分
                    realtimeTimelinessScore: this.shiXiaoXingScore.realtimeTimelinessScore,     // 实时及时性得分
                    periodicTimelinessScore: this.shiXiaoXingScore.periodicTimelinessScore,     // 周期及时性得分
                    timelinessRemarks: this.shiXiaoXingScore.timelinessRemarks,               // 时效性备注信息

                    // 可访问性评分相关
                    accessibilityScore: this.keFangWenxingScore.accessibilityScore,          // 可访问性评分
                    dataAccessibilityScore: this.keFangWenxingScore.dataAccessibilityScore,      // 数据可访问性得分
                    dataAvailabilityScore: this.keFangWenxingScore.dataAvailabilityScore,       // 数据可用性得分
                    accessibilityRemarks: this.keFangWenxingScore.accessibilityRemarks,            // 可访问性备注信息



                    // 其他信息
                    existingIssues: useAI && this.AIExistingIssues != '' ? this.AIExistingIssues : this.existingIssues,
                    evaluation: this.evaluation || '',   // 存在问题描述


                };

                console.log('生成报告请求参数:', dataQualityAssessment);

                // 调用后端接口生成报告
                const response = await this.$axios.post('/web/dataQuality/createEvaluationReport', dataQualityAssessment);

                console.log('useAI:', useAI)



                if (response.data && response.data.status === 200) {

                    if (useAI || buttonIndex == 2) {
                        this.sysReportName = response.data.object;
                        this.$message.success(`报告生成成功！文件名: ${this.sysReportName}`);

                        if (buttonIndex === 2) {
                            this.isGeneratingReport = false;
                        }
                        return
                    }
                    let basrUrl = '/www/lzw/work/tools/file/upload/'
                    // let basrUrl = '../DevelopFiles/file/upload/'
                    console.log("dawd", this.companyUserID);
                    console.log("this.registrationId", this.registrationId);
                    let reportUrl = basrUrl + this.companyUserID + '/' + this.registrationId + '/dataQuality/' + response.data.object
                    console.log("url:", reportUrl);
                    reportUrl = reportUrl.replace(/\\/g, '/');  // 将反斜杠替换为正斜杠
                    console.log("thisDataAssetAllInfo", this.thisDataAssetAllInfo);
                    console.log("thisCompanyAllInfo", this.thisCompanyAllInfo);
                    console.log("registry_info", this.existingIssues);
                    const aiArgs = {
                        asset_id: this.thisDataAssetAllInfo.assetName,
                        registry_info: {},
                        // registry_info: this.existingIssues,
                        company_name: this.thisCompanyAllInfo.companyName || null,
                        documents: [{ source: reportUrl }]
                    }
                    console.log("aiArgs:", aiArgs);

                    // process.env.VUE_APP_AI_BACKEND_BASE_URL
                    // const apiUrl = 'https://www.dacrec.com/api/report_tasks'; 

                    const apiUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + 'api/report_tasks';
                    try {
                        const response = await fetch(apiUrl, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(aiArgs)
                        });

                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }

                        const result = await response.json();
                        console.log('任务创建成功:', result);

                        // 检查是否返回了 task_id }}
                        if (result.task_id) {
                            // 创建轮询请求检查任务状态 }}
                            const pollTaskStatus = async (taskId) => {
                                const statusUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + `api/tasks/${taskId}`;

                                try {
                                    const statusResponse = await fetch(statusUrl);
                                    if (!statusResponse.ok) {
                                        throw new Error(`HTTP error! status: ${statusResponse.status}`);
                                    }

                                    const statusResult = await statusResponse.json();
                                    console.log('任务状态:', statusResult);

                                    // 根据任务状态进行处理 }}
                                    if (statusResult.status === 'completed') {
                                        // this.$message.success('AI报告生成完成！');
                                        // 这里可以处理完成后的逻辑，比如显示报告或下载链接 }}
                                        const resultUrl = process.env.VUE_APP_AI_BACKEND_BASE_URL + `api/tasks/${taskId}/result`;

                                        try {
                                            const resultResponse = await fetch(resultUrl);
                                            if (!resultResponse.ok) {
                                                throw new Error(`HTTP error! status: ${resultResponse.status}`);
                                            }

                                            const taskResult = await resultResponse.json();
                                            console.log('任务结果:', taskResult);
                                            console.log('评语:', taskResult.result.result.final_text);

                                            this.AIExistingIssues = taskResult.result.result.final_text;

                                            const startMarker = '（七）数据质量评价工作中发现的其他问题总结';
                                            let content = this.AIExistingIssues;

                                            if (this.AIExistingIssues.includes(startMarker)) {
                                                const startIndex = this.AIExistingIssues.indexOf(startMarker) + startMarker.length;
                                                content = this.AIExistingIssues.substring(startIndex).trim();
                                                console.log('提取标题后内容:', content);
                                            }

                                            this.AIExistingIssues = content;

                                            // 更新按钮状态
                                            this.isGeneratingAI = false;
                                            this.isAIReportGenerated = true;
                                            // 处理任务结果 }}
                                            this.$message.success('AI问题总结生成完成！');

                                            // 这里可以处理任务结果，比如显示报告内容或下载链接 }}
                                            // 例如：this.aiReportResult = taskResult; }}

                                            return taskResult;

                                        } catch (resultError) {
                                            console.error('获取任务结果失败:', resultError);
                                            this.$message.error('获取任务结果失败: ' + resultError.message);
                                            return null;
                                        }
                                        return statusResult;
                                    } else if (statusResult.status === 'failed') {
                                        this.isGeneratingAI = false;
                                        this.$message.error(`AI报告生成失败: ${statusResult.error || '未知错误'}`);
                                        return statusResult;
                                    } else {
                                        // 如果任务还在进行中，可以设置定时轮询 
                                        setTimeout(() => {
                                            pollTaskStatus(taskId);
                                        }, 5000); // 5秒后再次轮询 
                                    }
                                } catch (error) {
                                    this.isGeneratingAI = false;
                                    console.error('获取任务状态失败:', error);
                                    this.$message.error('获取任务状态失败: ' + error.message);
                                }
                            };

                            // 开始轮询任务状态 
                            pollTaskStatus(result.task_id);
                        } else {
                            console.warn('API响应中没有包含 task_id');
                        }

                        return result;
                    } catch (error) {
                        console.error('创建任务失败:', error);
                        throw error;
                    }
                } else {
                    this.$message.error(`报告生成失败: ${response.data.msg || '未知错误'}`);
                }

            } catch (error) {
                console.error('生成报告请求出错:', error);
                if (error.response) {
                    console.error('错误详情:', error.response.status, error.response.data);
                    this.$message.error(`生成报告失败: ${error.response.data?.msg || error.message}`);
                } else {
                    this.$message.error('生成报告失败: ' + error.message);
                }
            }
        },



        // 保存
        async save() {
            try {
                const submitData = {
                    registrationId: this.registrationId,           // 数据资产id
                    companyName: this.enterpriseInfoData.find(item => item.label === '企业名称')?.value,   // 企业名称
                    assetName: this.dataAssetInfoData.find(item => item.label === '数据资产名称')?.value,  // 数据资产名称
                    industry: this.dataAssetInfoData.find(item => item.label === '所属行业')?.value,   // 所属行业
                    dataDetailedFile: Array.isArray(this.dataQualityData.find(item => item.label === '抽样数据')?.value)
                        ? this.dataQualityData.find(item => item.label === '抽样数据')?.value.map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file)
                        : [this.dataQualityData.find(item => item.label === '抽样数据')?.value].map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file),   // 数据文件(仅文件名)
                    dataFieldFile: Array.isArray(this.dataQualityData.find(item => item.label === '字段信息')?.value)
                        ? this.dataQualityData.find(item => item.label === '字段信息')?.value.map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file)
                        : [this.dataQualityData.find(item => item.label === '字段信息')?.value].map(file =>
                            typeof file === 'string' ? file.split('/').pop() : file.name || file),      // 字段文件(仅文件名)
                    oldDataHandle: this.dataQualityData.find(item => item.label === '冷数据处理方式')?.value,      // 冷数据处理方式
                    dataQualityScore: this.dataQualityScore, // 数据质量总评分


                    source: this.sourceDetail,  // 数据来源
                    purpose: this.purpose,  // 数据用途
                    workExecution: this.workExecution,  // 工作执行

                    // 元素总数和记录总数
                    elementsNum: this.totalElements,
                    linesNum: this.totalRecords,

                    qualityProblemList: this.qualityProblems,  // 问题列表
                    // 规范性评分相关
                    standardizationScore: this.guiFanXingScore.standardizationScore,   // 规范性评分
                    domainStandardScore: this.guiFanXingScore.domainStandardScore,    // 值域规范得分
                    domainStandardNum: this.guiFanXingScore.domainProblemCount,     // 值域规范问题数
                    metadataStandardScore: this.guiFanXingScore.metadataStandardScore,  // 元数据规范得分
                    metadataStandardNum: this.guiFanXingScore.metadataProblemCount,   // 元数据规范问题数
                    formatStandardScore: this.guiFanXingScore.formatStandardScore,    // 格式规范得分
                    formatStandardNum: this.guiFanXingScore.formatProblemCount,     // 格式规范问题数
                    sensitiveDataScore: this.guiFanXingScore.sensitiveDataScore,     // 敏感数据脱敏得分
                    sensitiveDataNum: this.guiFanXingScore.sensitiveProblemCount,  // 敏感数据问题数
                    standardizationRemarks: this.guiFanXingScore.standardizationRemarks,     // 规范性备注信息

                    // 完整性评分相关
                    completenessScore: this.wanZhengXingScore.completenessScore,       // 完整性评分
                    elementFillRateScore: this.wanZhengXingScore.elementFillRateScore,    // 元素填充率得分
                    elementFillRateNum: this.wanZhengXingScore.elementProblemCount,     // 元素填充率问题数
                    recordFillRateScore: this.wanZhengXingScore.recordFillRateScore,     // 记录填充率得分
                    recordFillRateNum: this.wanZhengXingScore.recordProblemCount,      // 记录填充率问题数
                    completenessRemarks: this.wanZhengXingScore.completenessRemarks,         // 完整性备注信息

                    // 准确性评分相关
                    accuracyScore: this.zhunQueXingScore.accuracyScore,         // 准确性评分
                    contentAccuracyScore: this.zhunQueXingScore.contentAccuracyScore,  // 内容准确率得分
                    contentAccuracyNum: this.zhunQueXingScore.contentProblemCount,   // 内容准确率问题数
                    formatAccuracyScore: this.zhunQueXingScore.formatAccuracyScore,   // 格式准确率得分
                    formatAccuracyNum: this.zhunQueXingScore.formatAccuracyProblemCount, // 格式准确率问题数
                    repetitionRateScore: this.zhunQueXingScore.repetitionRateScore,   // 记录重复率得分
                    repetitionRateNum: this.zhunQueXingScore.repetitionProblemCount, // 记录重复率问题数
                    accuracyRemarks: this.zhunQueXingScore.accuracyRemarks,           // 准确性备注信息

                    // 一致性评分相关
                    consistencyScore: this.yiZhiXingScore.consistencyScore,            // 一致性评分
                    sameDataConsistencyScore: this.yiZhiXingScore.sameDataConsistencyScore,    // 相同数据一致性得分
                    sameDataConsistencyNum: this.yiZhiXingScore.consistencyProblemCount,    // 相同数据一致性问题数
                    consistencyRemarks: this.yiZhiXingScore.consistencyRemarks,              // 一致性备注信息

                    // 时效性评分相关
                    timelinessScore: this.shiXiaoXingScore.timelinessScore,             // 时效性评分
                    realtimeTimelinessScore: this.shiXiaoXingScore.realtimeTimelinessScore,     // 实时及时性得分
                    periodicTimelinessScore: this.shiXiaoXingScore.periodicTimelinessScore,     // 周期及时性得分
                    timelinessRemarks: this.shiXiaoXingScore.timelinessRemarks,               // 时效性备注信息

                    // 可访问性评分相关
                    accessibilityScore: this.keFangWenxingScore.accessibilityScore,          // 可访问性评分
                    dataAccessibilityScore: this.keFangWenxingScore.dataAccessibilityScore,      // 数据可访问性得分
                    dataAvailabilityScore: this.keFangWenxingScore.dataAvailabilityScore,       // 数据可用性得分
                    accessibilityRemarks: this.keFangWenxingScore.accessibilityRemarks,            // 可访问性备注信息

                    existingIssues: this.existingIssues,            // 存在问题描述
                    evaluation: this.evaluation,                // 综合评价
                    // evaluationReport: platformQualityReportUrl,                // 评估报告

                    operator: this.userInfo.id,           // 操作人
                };
                console.log(submitData);


                // 调用表单提交接口
                const response = await this.$axios.post('/web/dataQualityDetail/review/storage', submitData, {
                    headers: {
                        'X-User-Id': this.userInfo.id
                    }
                });


                if (response.data && response.data.status === 200) {
                    // 提交成功后显示确认弹窗
                    this.$confirm('保存成功！', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        showCancelButton: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {

                    });
                } else {
                    this.$message.error('提保存失败: ' + (response.data.msg || '未知错误'));
                }
            } catch (error) {
                console.error('保存失败:', error);
                this.$message.error('保存失败: ' + error.message);
            }


        },

        // 关闭
        close(targetPage = '/home') {
            const fullPath = this.$route.fullPath;
            const currentPath = this.$route.path;

            // 1. 先跳转到指定页面
            if (currentPath !== targetPage) {
                this.$router.push(targetPage).then(() => {
                    // 2. 跳转成功后延迟关闭当前标签页
                    setTimeout(() => {
                        this.closeTab(fullPath);
                    }, 100);
                }).catch(() => {
                    // 跳转失败时仍然尝试关闭
                    this.closeTab(fullPath);
                });
            } else {
                // 如果已经在目标页面，直接关闭
                this.closeTab(fullPath);
            }
        },

        // 提取关闭标签页的公共方法
        closeTab(fullPath) {
            this.$emit('close-tab', fullPath);

            let parent = this.$parent;
            while (parent) {
                if (typeof parent.removeTab === 'function') {
                    parent.removeTab(fullPath);
                    break;
                }
                parent = parent.$parent;
            }
        },


    },
    computed: {

        isSubmitDisabled() {
            // 检查基础数据是否存在
            if (!this.registrationId || this.reportFile.length === 0) {
                return true;
            }

            // 检查元素总数和记录总数是否填写
            if (!this.totalElements || this.totalElements === 0 || !this.totalRecords || this.totalRecords === 0) {
                return true;
            }

            // 检查各评分模块的问题数是否填写完整
            const problemCounts = [
                // 规范性评分问题数检查
                this.guiFanXingScore.domainProblemCount,
                this.guiFanXingScore.metadataProblemCount,
                this.guiFanXingScore.formatProblemCount,
                this.guiFanXingScore.sensitiveProblemCount,

                // 完整性评分问题数检查
                this.wanZhengXingScore.elementProblemCount,
                this.wanZhengXingScore.recordProblemCount,

                // 准确性评分问题数检查
                this.zhunQueXingScore.contentProblemCount,
                this.zhunQueXingScore.formatAccuracyProblemCount,
                this.zhunQueXingScore.repetitionProblemCount,

                // 一致性评分问题数检查
                this.yiZhiXingScore.consistencyProblemCount,

                // 时效性评分检查（至少填写实时或周期中的一个）
                this.shiXiaoXingScore.timelinessScore,

                // 可访问性评分检查
                this.keFangWenxingScore.accessibilityScore,
                this.keFangWenxingScore.dataAccessibilityScore,
                this.keFangWenxingScore.dataAvailabilityScore,

                // 最终信息检查
                this.dataQualityScore,
                this.existingIssues,
                this.evaluation
            ];

            // 检查所有必填项是否都有值（问题数可以是0，但不能是undefined或null）
            const isAllFieldsFilled = problemCounts.every(field => field !== undefined && field !== null);

            // 时效性特殊检查（至少填写实时或周期中的一个）
            const isTimelinessValid = (this.shiXiaoXingScore.realtimeTimelinessScore !== '' ||
                this.shiXiaoXingScore.periodicTimelinessScore !== '') &&
                this.shiXiaoXingScore.timelinessScore !== '';

            return !isAllFieldsFilled || !isTimelinessValid;
        }
    }
}
</script>

<style scoped>
.score-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    margin-bottom: 15px;
}

.action-buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin: 10px 0;
}

.data-evaluation-page {
    padding: 15px;
    background-color: #f5f5f5;
}

.box-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.box-card>>>.el-card__header {
    background-color: #f0f0f0;
    font-weight: bold;
    font-size: 16px;
    color: #333;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.el-form-item {
    margin-bottom: 10px;
}

.el-form-item>>>.el-form-item__label {
    color: #666;
    font-weight: normal;
}


.level1-flex-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: flex-start;
    margin: 0 -10px;
}

.level1-flex-item {
    flex: 0 0 calc(33.333% - 14px);
    box-sizing: border-box;
    padding: 0 10px;
    margin-bottom: 20px;
    min-width: 300px;
}

.level1-card {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 15px;
    background-color: #fff;
    width: 100%;
    height: 100%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
}


.level1-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 2px solid #409EFF;
    flex-shrink: 0;
}

.level1-name {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    flex: 1;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


.level2-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
}

.level2-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #67C23A;
    transition: all 0.2s ease;
}


.level2-name {
    font-size: 14px;
    color: #606266;
    flex: 1;
    margin-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 响应式调整 */
@media (max-width: 1200px) {
    .level1-flex-item {
        flex: 0 0 calc(50% - 10px);
        /* 中等屏幕显示2列 */
    }
}

@media (max-width: 768px) {
    .level1-flex-item {
        flex: 0 0 100%;
        /* 小屏幕显示1列 */
    }
}

/* 确保所有卡片高度一致 */
.level1-flex-item {
    display: flex;
}

.level1-weight-input {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    color: #409EFF;
    background-color: #ecf5ff;
    padding: 4px 10px;
    border-radius: 4px;
    white-space: nowrap;
}

.level1-weight-input>>>.el-input-number {
    width: 55px;
}

.level1-weight-input>>>.el-input-number .el-input__inner {
    text-align: center;
    font-weight: bold;
    color: #409EFF;
    background-color: transparent;
    border: none;
    height: 28px;
    line-height: 28px;
    font-size: 18px;

}

/* 隐藏输入框的边框和背景 */
.level1-weight-input>>>.el-input-number .el-input__inner {
    border: none;
    background: transparent;
    box-shadow: none;
    padding: 0;
}

/* 确保没有控件显示 */
.level1-weight-input>>>.el-input-number .el-input-number__decrease,
.level1-weight-input>>>.el-input-number .el-input-number__increase {
    display: none !important;
}

.weight-percent {
    font-weight: bold;
    color: #409EFF;
}

.level2-weight-input {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: #67C23A;
    background-color: #f0f9eb;
    padding: 2px 8px;
    border-radius: 3px;
    white-space: nowrap;
}

.level2-weight-input>>>.el-input-number {
    width: 45px;


}

.level2-weight-input>>>.el-input-number .el-input__inner {
    text-align: center;
    font-weight: bold;
    color: #67C23A;
    background-color: transparent;
    border: none;

    height: 24px;
    line-height: 24px;
    font-size: 13px;
}

/* 隐藏输入框的边框和背景 */
.level2-weight-input>>>.el-input-number .el-input__inner {
    border: none;
    background: transparent;
    box-shadow: none;
    padding: 0;

}

/* 确保没有控件显示 */
.level2-weight-input>>>.el-input-number .el-input-number__decrease,
.level2-weight-input>>>.el-input-number .el-input-number__increase {
    display: none !important;
}

/* 确保所有卡片高度一致 */
.level1-flex-item {
    display: flex;
}



/* 元素总数配置样式 */
.total-elements-config {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e4e7ed;
}

.config-item {
    display: flex;
    align-items: center;
}

.config-label {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    margin-right: 15px;
    min-width: 100px;
}

.total-elements-config>>>.el-input-number {
    width: 200px;
}

.total-elements-config>>>.el-input-number .el-input__inner {
    text-align: center;
    font-weight: bold;
    color: #409EFF;
    background-color: white;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 0 10px;
    height: 32px;
    line-height: 32px;
}

.total-elements-config>>>.el-input-number .el-input__inner:focus {
    border-color: #409EFF;
    outline: none;
}

.total-elements-config>>>.el-input-number .el-input-number__decrease,
.total-elements-config>>>.el-input-number .el-input-number__increase {
    display: none !important;
}

/* 确保所有卡片高度一致 */
.level1-flex-item {
    display: flex;
}


/* 问题详述表格样式 */
.quality-problems-table>>>.el-table {
    margin-top: 10px;
}

.quality-problems-table>>>.el-table__row {
    height: auto;
}

.quality-problems-table>>>.el-table__cell {
    padding: 8px 0;
}

.quality-problems-table>>>.el-textarea__inner {
    min-height: 60px;
    resize: vertical;
}

/* 操作按钮样式 */
.quality-problems-table>>>.el-button--mini {
    padding: 5px;
}

.quality-problems-table>>>.el-button--danger {
    background-color: #f56c6c;
    border-color: #f56c6c;
}

.quality-problems-table>>>.el-button--danger:hover {
    background-color: #f78989;
    border-color: #f78989;
}

/* 新增的响应式样式 */
.score-input-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;
}

.score-label {
    font-size: 14px;
    color: #606266;
    white-space: nowrap;
    flex-shrink: 0;
}

.score-input {
    min-width: 50px !important;
    flex: 1;
    max-width: 120px;
}

.score-input>>>.el-input__inner {
    text-align: center;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
}

.score-display {
    font-size: 14px;
    color: #409EFF;
    font-weight: bold;
    white-space: nowrap;
    flex-shrink: 0;
}

/* 响应式调整 */
@media (max-width: 1600px) {
    .score-label {
        font-size: 13px;
    }

    .score-input {
        max-width: 100px;
    }

    .score-display {
        font-size: 13px;
    }
}

@media (max-width: 1400px) {
    .score-input-container {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }

    .score-label {
        font-size: 12px;
        width: 100%;
    }

    .score-input {
        width: 100%;
        max-width: 100%;
    }

    .score-input>>>.el-input__inner {
        font-size: 13px;
        height: 30px;
        line-height: 30px;
    }

    .score-display {
        font-size: 12px;
        width: 100%;
    }
}

@media (max-width: 1200px) {
    .score-label {
        font-size: 11px;
    }

    .score-input>>>.el-input__inner {
        font-size: 12px;
        height: 28px;
        line-height: 28px;
    }

    .score-display {
        font-size: 11px;
    }
}

@media (max-width: 992px) {
    .score-input-container {
        flex-direction: row;
        align-items: center;
        flex-wrap: nowrap;
    }

    .score-label {
        font-size: 10px;
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .score-input {
        flex: 0 0 60px;
        min-width: 50px !important;
    }

    .score-input>>>.el-input__inner {
        font-size: 11px;
        height: 26px;
        line-height: 26px;
        padding: 0 4px;
    }

    .score-display {
        font-size: 10px;
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

/* 确保在超小屏幕上仍然可读 */
@media (max-width: 768px) {
    .score-input-container {
        flex-wrap: wrap;
    }

    .score-label {
        font-size: 9px;
        width: 100%;
    }

    .score-input {
        flex: 0 0 50px;
        min-width: 50px !important;
    }

    .score-input>>>.el-input__inner {
        font-size: 10px;
        height: 24px;
        line-height: 24px;
        padding: 0 2px;
    }

    .score-display {
        font-size: 9px;
        width: 100%;
    }
}

.compact-panel {
    padding: 12px;
    background: #f8f9fa;
    border-radius: 6px;
    min-width: 320px;
}

.compact-section {
    margin-bottom: 12px;
}

.compact-section:last-child {
    margin-bottom: 0;
}

.compact-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.compact-label {
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
}

.compact-radio {
    margin-right: 4px;
}

.compact-btn {
    height: 32px;
    font-size: 13px;
    padding: 0 16px;
}

.file-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: white;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
}

.file-name {
    flex: 1;
    font-size: 13px;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 8px;
}

.file-buttons {
    flex-shrink: 0;
    display: flex;
    gap: 4px;
}

.file-btn {
    padding: 4px 8px;
    font-size: 12px;
}

.file-btn.preview {
    color: #409eff;
}

.file-btn.preview:hover {
    color: #66b1ff;
}

.file-btn.download {
    color: #67c23a;
}

.file-btn.download:hover {
    color: #85ce61;
}
</style>